// src/constants.ts
var TIMEZONE = "Asia/Tashkent";
var TIMEZONE_UTC_OFFSET_MINUTES = 300;
var WEEK_START_ISO_WEEKDAY = 1;
var WEEKLY_RECEIPT_LIMIT = 20;
var RECEIPT_MAX_AGE_DAYS = 10;
var ACCOUNT_DELETION_DAYS = 30;
var OFERTA_MIN_AGE_YEARS = 18;
var RECEIPT_POINTS_RATE = 0.02;
var OVER_LIMIT_RECEIPT_MIN_TOTAL = 1e5;
var OVER_LIMIT_RECEIPT_MAX_TOTAL = 1e6;
var OVER_LIMIT_RECEIPT_POINTS = 200;
var PHOTO_POINTS = 200;
var PHOTO_MIN_CONFIRMED_ITEMS = 1;
var PRESIGNED_UPLOAD_TTL_SECONDS = 300;
var PRESIGNED_READ_TTL_SECONDS = 120;
var PHOTO_MAX_UPLOAD_BYTES = 10 * 1024 * 1024;
var PHOTO_ALLOWED_MIME_TYPES = ["image/jpeg", "image/png", "image/webp"];
var PHOTO_MAX_RECOGNISED_ITEMS = 12;
var PHOTO_ITEM_NAME_MAX_LENGTH = 200;
var PHOTO_RECOGNITION_RATE_LIMIT_PER_MINUTE = 10;
var FOOD_POINTS = 300;
var TICKETS_PER_FOOD = 1;
var DAILY_FOOD_PHOTO_LIMIT = 3;
var FOOD_MAX_RECOGNISED_ITEMS = 6;
var TICKETS_PER_RECEIPT = 1;
var TICKETS_PER_PHOTO = 1;
var DAILY_SCAN_TICKET_LIMIT = 5;
var WELCOME_POINTS = 1e3;
var REFERRAL_POINTS = 2e3;
var REFERRAL_TICKETS = 5;
var WEEKLY_REFERRAL_TICKET_CAP = 50;
var REFERRAL_START_PARAM_PREFIX = "ref_";
var REFERRAL_FRIENDS_LIST_LIMIT = 50;
var DAILY_DRAW_WINNER_COUNT = 1;
var DAILY_DRAW_PRIZE_SOM = 1e5;
var MONTHLY_DRAW_WINNER_COUNT = 1;
var DRAW_MAX_WINNERS = 10;
var DRAW_PRIZE_LABEL_MAX_LENGTH = 200;
var DAILY_DRAW_TIME_HHMM = "20:00";
var WEEKLY_DRAW_TIME_HHMM = "20:00";
var MONTHLY_DRAW_TIME_HHMM = "20:00";
var DRAW_REVEAL_OFFSET_MS_DEFAULT = 0;
var DRAW_CULMINATION_CANDIDATE_MAX = 1;
var DRAW_VIDEO_EMBED_ALLOWED_HOSTS = [
  "www.youtube.com",
  "youtube.com",
  "www.youtube-nocookie.com",
  "youtube-nocookie.com",
  "t.me"
];
var ACCESS_TOKEN_TTL_SECONDS = 15 * 60;
var REFRESH_TOKEN_TTL_SECONDS = 30 * 24 * 60 * 60;
var INITDATA_MAX_AGE_SECONDS = 24 * 60 * 60;
var ADMIN_ACCESS_TOKEN_TTL_SECONDS = 60 * 60;
var BROADCAST_OVERLAY_TOKEN_TTL_SECONDS = 12 * 60 * 60;
var BROADCAST_OVERLAY_POLL_INTERVAL_MS = 650;
var BROADCAST_OVERLAY_STALE_AFTER_MS = 5e3;
var BROADCAST_OVERLAY_SEEN_TTL_SECONDS = 300;
var BROADCAST_OVERLAY_REQUESTS_PER_MINUTE = 600;
var ADMIN_LOGIN_RATE_LIMIT_PER_MINUTE = 10;
var ADMIN_USER_HISTORY_LIMIT = 20;
var ADMIN_STATS_TREND_DAYS = 30;
var ADMIN_STATS_CACHE_SECONDS = 60;
var ADMIN_USER_LOOKUP_AUDIT_WINDOW_MS = 15 * 60 * 1e3;
var ADMIN_PHOTO_READ_TTL_SECONDS = 600;
var ADMIN_TICKET_AUDIT_LIMIT = 20;
var ADMIN_POINTS_ADJUST_MAX = 1e5;
var ADMIN_EXPORT_MAX_RANGE_DAYS = 92;
var ADMIN_EXPORT_CHUNK_SIZE = 500;
var RECEIPT_DETAILS_QUEUE = "fetch_receipt_details";
var RECEIPT_DETAILS_DLQ = "fetch_receipt_details_dlq";
var SCRAPER_MAX_ATTEMPTS = 5;
var RECEIPT_MAX_ITEMS = 5e3;
var SCRAPER_BACKOFF_BASE_MS = 3e4;
var QUEUE_SUCCESS_RETENTION_SECONDS = 24 * 60 * 60;
var QUEUE_DLQ_RETENTION_SECONDS = 30 * 24 * 60 * 60;
var TICKET_POOL_CRON = "5 0 * * *";
var RECONCILIATION_CRON = "* * * * *";
var RECONCILIATION_MIN_AGE_MS = 6e4;
var SCRAPER_RESTART_AFTER_JOBS = 100;
var SCRAPER_RESTART_AFTER_MS = 2 * 60 * 60 * 1e3;
var SCRAPER_POLL_INTERVAL_MS = 3e3;
var SCRAPER_CLAIM_BATCH = 10;
var PENDING_PUBLICATION_RETRY_DELAYS_MS = [
  10 * 60 * 1e3,
  // 10 min — most receipts publish quickly
  60 * 60 * 1e3,
  // 1 h
  6 * 60 * 60 * 1e3,
  // 6 h
  24 * 60 * 60 * 1e3,
  // 24 h
  48 * 60 * 60 * 1e3
  // 48 h
];
var PENDING_PUBLICATION_MAX_AGE_MS = 72 * 60 * 60 * 1e3;
var SCRAPER_JOB_TIMEOUT_MS = 6e4;
var DEGRADED_MODE_SUCCESS_RATIO_THRESHOLD = 0.5;
var DEGRADED_MODE_SAMPLE_SIZE = 20;
var DEGRADED_MODE_SKIPS_REVOCATION = true;
var DEGRADED_MODE_RETRY_DELAY_MS = 5 * 60 * 1e3;
var SCAN_RATE_LIMIT_PER_MINUTE = 10;
var SCAN_RATE_LIMIT_PER_IP_PER_MINUTE = 600;
var SLOT_CONTENTION_RETRIES = 3;
var INVALID_ORIGIN_STRIKE_LIMIT = 5;
var INVALID_ORIGIN_BLOCK_SECONDS = 15 * 60;
var HMAC_TIMESTAMP_HEADER = "x-qaytim-timestamp";
var HMAC_SIGNATURE_HEADER = "x-qaytim-signature";
var HMAC_MAX_CLOCK_SKEW_MS = 5 * 60 * 1e3;
var IDEMPOTENCY_KEY_HEADER = "idempotency-key";
var IDEMPOTENCY_TTL_SECONDS = 24 * 60 * 60;
var IDEMPOTENCY_IN_FLIGHT_TIMEOUT_SECONDS = 60;
var TELEGRAM_MAX_MESSAGES_PER_SECOND = 25;
var NOTIFICATION_MAX_ATTEMPTS = 3;
var NOTIFICATION_BACKOFF_BASE_MS = 1e4;
var NOTIFICATION_DISPATCH_CRON = "* * * * *";
var DRAW_REMINDER_CRON = "* * * * *";
var NOTIFICATION_CLAIM_LEASE_MS = 6e4;
var NOTIFICATION_STUCK_AFTER_MS = 5 * 6e4;
var DRAW_REMINDER_LEAD_MINUTES = 30;
var DRAW_SOCKET_NAMESPACE_PREFIX = "draw:";
var DRAW_FIRST_SEQ = 1;
var REALTIME_REDIS_CONNECT_TIMEOUT_MS = 5e3;
var SURVEY_ID = "pepsico_pilot_v1";
var SURVEY_REWARD_POINTS = 400;
var SURVEY_FIELD_WINDOW_HOURS = 72;
var SURVEY_SPEED_FILTER_SECONDS = 25;
var SURVEY_CALLBACK_PREFIX = "sv";

// src/domain.ts
var ReceiptStatus = {
  /** Accepted, reward granted, detail job not yet picked up. */
  PENDING_DETAILS: "pending_details",
  /** A scraper worker has the job. */
  DETAILS_FETCHING: "details_fetching",
  /** Items written — the only state that counts for referral/draw/analytics. */
  DETAILS_READY: "details_ready",
  /** Terminal failure after retries → reward revoked (unless degraded mode). */
  DETAILS_FAILED: "details_failed"
};
var TicketStatus = {
  /** Acquired today; plays in the NEXT day's daily draw. */
  PENDING_DAILY: "pending_daily",
  /** Has played its one daily draw. */
  PLAYED_DAILY: "played_daily",
  /** Intermediate pool — no weekly draw exists. */
  IN_WEEKLY_POOL: "in_weekly_pool",
  /** Waiting for the monthly draw of its `month_key`. */
  IN_MONTHLY_POOL: "in_monthly_pool",
  /** Expired — has been through the monthly draw. */
  FINISHED: "finished",
  /** Terminal: won a draw; excluded from all future draws. */
  WON: "won",
  /** Terminal: reward reversed (details_failed). */
  REVOKED: "revoked",
  /** Held out of draws pending admin review. */
  FRAUD_REVIEW: "fraud_review"
};
var TERMINAL_TICKET_STATUSES = [
  TicketStatus.WON,
  TicketStatus.REVOKED,
  TicketStatus.FINISHED
];
var DRAW_INELIGIBLE_TICKET_STATUSES = [
  ...TERMINAL_TICKET_STATUSES,
  TicketStatus.FRAUD_REVIEW
];
var TicketSource = {
  RECEIPT: "receipt",
  PHOTO: "photo",
  /** A food photo (C10). Counted by its OWN daily meter — see `DAILY_FOOD_PHOTO_LIMIT`. */
  FOOD: "food",
  REFERRAL: "referral",
  /**
   * Kompensatsiya bileti — admin qo'lda bergan.
   *
   * Hech qaysi skanga bog'lanmaydi (chek ham, rasm ham, taklif ham yo'q) va hech qaysi kunlik
   * yoki haftalik hisoblagichni band qilmaydi: bu tizim xatosi uchun tovon, ya'ni
   * foydalanuvchining o'z imkoniyati hisobiga tushmasligi kerak.
   */
  ADMIN: "admin"
};
var SCAN_TICKET_SOURCES = [
  TicketSource.RECEIPT,
  TicketSource.PHOTO
];
var PhotoScanStatus = {
  /** Pre-signed URL issued, bytes not confirmed yet. */
  AWAITING_UPLOAD: "awaiting_upload",
  /** Vision provider is running / has run; user is on the C8 review screen. */
  IN_REVIEW: "in_review",
  /** >= 1 item confirmed, reward granted. */
  CONFIRMED: "confirmed",
  /** Vision recognised nothing — no reward. */
  REJECTED: "rejected",
  /** Review left zero items — no reward. */
  VOID: "void"
};
var PhotoSubject = {
  /** C6–C9 — shelf/basket products, reviewed item by item. */
  PRODUCT: "product",
  /** C10 — a meal. */
  FOOD: "food"
};
var PointTransactionType = {
  RECEIPT_REWARD: "receipt_reward",
  RECEIPT_OVER_LIMIT_REWARD: "receipt_over_limit_reward",
  PHOTO_REWARD: "photo_reward",
  FOOD_REWARD: "food_reward",
  REFERRAL_REWARD: "referral_reward",
  /** Telefon tasdiqlanganda bir marta beriladigan kutib olish balli (`WELCOME_POINTS`). */
  WELCOME_BONUS: "welcome_bonus",
  /** So'rovnomani to'liq yakunlaganga beriladigan ball (`SURVEY_REWARD_POINTS`). */
  SURVEY_REWARD: "survey_reward",
  REVERSAL: "reversal",
  ADMIN_ADJUSTMENT: "admin_adjustment",
  /** Sovg'aga almashtirish — ballning yagona SARFLANISH yo'li. Har doim manfiy. */
  REWARD_REDEMPTION: "reward_redemption",
  /** Bekor qilingan almashtirish uchun ball qaytarildi. Har doim musbat. */
  REWARD_REFUND: "reward_refund"
};
var RewardRedemptionStatus = {
  PENDING: "pending",
  DELIVERED: "delivered",
  CANCELLED: "cancelled"
};
var DrawType = {
  DAILY: "daily",
  /**
   * Haftalik efir — bir hafta ichida kunlik efirda o'ynagan biletlar orasidan.
   *
   * Kunlik efir kabi `draw_date` bilan kalitlanadi, ammo bu sana — o'sha HAFTANING dushanbasi
   * (`weekKey`). Alohida ustun kerak emas: `@@unique([type, draw_date])` bir turdagi ikkinchi
   * efirni allaqachon to'sadi, va tur bo'yicha ajratilgani uchun bir kunda ham kunlik, ham
   * haftalik efir bo'lishi mumkin.
   */
  WEEKLY: "weekly",
  MONTHLY: "monthly"
};
var DrawStatus = {
  SCHEDULED: "scheduled",
  COMPLETED: "completed",
  POSTPONED: "postponed"
};
var DrawRevealKind = {
  /** How many tickets are playing — the first thing shown. */
  TICKET_COUNT: "ticket_count",
  /** One more server-authored character of the winning ticket code, plus remaining candidates. */
  SHORTLIST: "shortlist",
  /** The winning ticket. */
  WINNER: "winner"
};
var NotificationStatus = {
  QUEUED: "queued",
  SENT: "sent",
  FAILED: "failed"
};
var NotificationType = {
  RECEIPT_REVOKED: "receipt_revoked",
  /**
   * The scraper confirmed the receipt and the points landed (P6.1). This replaced
   * `receipt_reward_corrected`: with no total in the QR there is no client claim to correct —
   * the first number the user ever gets IS the verified one. (The old value survives in the
   * Postgres enum; nothing writes it.)
   */
  RECEIPT_POINTS_CREDITED: "receipt_points_credited",
  DRAW_WIN: "draw_win",
  DRAW_REMINDER: "draw_reminder",
  /**
   * Efir yakunlangach BUTUN bazaga ketadigan g'oliblar e'loni.
   *
   * `DRAW_WIN` dan farqi ataylab: u BITTA odamga "siz yutdingiz" deydi va g'olibning o'zi undan
   * ro'yxatdan chiqariladi, bu esa qolgan hammaga "efir shunday yakunlandi" deydi. Ikkalasi bir
   * xil tip bo'lganida `(draw_id, user_id, type)` yagonaligi g'olibning tabrigini jimgina
   * e'lonning nusxasi deb hisoblab, o'zining shaxsiy xabarini yo'q qilardi.
   */
  DRAW_RESULT: "draw_result",
  REFERRAL_BONUS: "referral_bonus",
  /**
   * Telefon tasdiqlandi va kutib olish balli qo'shildi.
   *
   * Bot chatidagi `phoneSaved` xabaridan ALOHIDA: u "raqam saqlandi" deydi va darhol yuboriladi,
   * bu esa "sizga 1 000 ball qo'shildi" deydi va bildirishnoma navbatidan o'tadi, ya'ni admin
   * panelda matni tahrirlanadi va yuborilgani auditda ko'rinadi.
   */
  WELCOME_BONUS: "welcome_bonus",
  /**
   * Sovg'a topshirildi. Almashtirish PAYTIDA xabar yuborilmaydi — o'sha lahzada foydalanuvchi
   * ilovada turibdi va tasdiqni ekranda ko'radi; bot xabari faqat u ilovadan chiqib ketgandan
   * keyin sodir bo'ladigan ikkita voqea uchun.
   */
  REWARD_DELIVERED: "reward_delivered",
  /** Sovg'a buyurtmasi admin tomonidan bekor qilindi va ball qaytarildi. */
  REWARD_CANCELLED: "reward_cancelled",
  /**
   * So'rovnomaga taklif (1-to'lqin).
   *
   * Navbatdan o'tadi, chunki u ommaviy: `/stop`, moderator bani va botni bloklash filtrlari,
   * tezlik chegarasi, `retry_after` va qayta urinish — hammasi mavjud dispatcherda allaqachon
   * bor (arxitektura, ADR-10). Matn esa spec JSON dan `payload` orqali keladi, shablon
   * faylidan emas: so'rovnoma matni tadqiqot asbobi va uni admin panelda tahrirlash MUMKIN
   * EMAS — o'zgargan savol o'zgargan tadqiqot degani.
   */
  SURVEY_INVITE: "survey_invite",
  /** So'rovnoma eslatmasi (2-to'lqin) — faqat javob bermaganlarga. */
  SURVEY_REMINDER: "survey_reminder"
};
var ReceiptScanOutcome = {
  /** Inside both limits: 1 ticket now, 2% points at details_ready. Screen C3. */
  FULL_REWARD: "full_reward",
  /** Inside weekly limit, daily ticket limit full: no ticket, 2% points at details_ready. C3. */
  POINTS_ONLY: "points_only",
  /**
   * Over the weekly limit: no ticket; fixed points at details_ready if the verified total is
   * inside 100k–1M, zero otherwise. Screen C3b.
   */
  OVER_LIMIT_FIXED: "over_limit_fixed"
};
var PhotoScanOutcome = {
  /** 200 points + 1 ticket. Screen C9. */
  FULL_REWARD: "full_reward",
  /** Daily ticket limit filled during review: points only. Screen C9b. */
  POINTS_ONLY: "points_only"
};

// src/errors.ts
var ErrorCode = {
  // --- auth ---------------------------------------------------------------
  /** initData missing / malformed / bad HMAC / expired auth_date. */
  AUTH_INVALID_INITDATA: "AUTH_INVALID_INITDATA",
  AUTH_TOKEN_EXPIRED: "AUTH_TOKEN_EXPIRED",
  AUTH_TOKEN_INVALID: "AUTH_TOKEN_INVALID",
  AUTH_REFRESH_INVALID: "AUTH_REFRESH_INVALID",
  AUTH_FORBIDDEN: "AUTH_FORBIDDEN",
  /**
   * Hisobda tasdiqlangan telefon raqami yo'q — ekran telefon so'rash oynasini ochishi kerak.
   *
   * `details.action` (ixtiyoriy) — foydalanuvchi qilmoqchi bo'lgan ish, klient uni matnga
   * qo'yadi: "«Chek skanlash» uchun telefon raqam orqali ro'yxatdan o'tish zarur".
   */
  PHONE_REQUIRED: "PHONE_REQUIRED",
  // --- receipt scan (C1 → C3/C3b/C4/C5) -----------------------------------
  /** QR origin != configured tax-authority origin → screen C5. */
  RECEIPT_INVALID_ORIGIN: "RECEIPT_INVALID_ORIGIN",
  /** QR value is not a parseable URL → screen C5. */
  RECEIPT_INVALID_QR: "RECEIPT_INVALID_QR",
  /** Issued more than RECEIPT_MAX_AGE_DAYS ago → C5-type error. */
  RECEIPT_TOO_OLD: "RECEIPT_TOO_OLD",
  /** Already scanned by anyone, ever (global unique fiscal key) → screen C4. */
  RECEIPT_DUPLICATE: "RECEIPT_DUPLICATE",
  // --- photo scan (C6 → C9/C9b) -------------------------------------------
  /** Shared daily scan-ticket limit is full → photo scanner blocked until tomorrow. */
  PHOTO_DAILY_LIMIT_REACHED: "PHOTO_DAILY_LIMIT_REACHED",
  /** Vision AI recognised zero products → scan rejected, no reward. */
  PHOTO_NO_ITEMS_RECOGNISED: "PHOTO_NO_ITEMS_RECOGNISED",
  /** Review left zero items → scan void, no reward. */
  PHOTO_NO_ITEMS_CONFIRMED: "PHOTO_NO_ITEMS_CONFIRMED",
  PHOTO_UPLOAD_TOO_LARGE: "PHOTO_UPLOAD_TOO_LARGE",
  PHOTO_UPLOAD_TYPE_NOT_ALLOWED: "PHOTO_UPLOAD_TYPE_NOT_ALLOWED",
  PHOTO_UPLOAD_EXPIRED: "PHOTO_UPLOAD_EXPIRED",
  PHOTO_ALREADY_CONFIRMED: "PHOTO_ALREADY_CONFIRMED",
  /**
   * The vision provider could not be reached or answered with something unusable (network,
   * quota, 5xx, timeout, malformed JSON).
   *
   * Deliberately NOT `PHOTO_NO_ITEMS_RECOGNISED`: "we found no products in your photo" is a
   * verdict on the image and burns the attempt, while this is a verdict on our own
   * infrastructure. The photo is already in storage and the scan stays `AWAITING_UPLOAD`, so the
   * client re-runs recognition over the SAME object instead of asking the user to shoot again.
   */
  VISION_UNAVAILABLE: "VISION_UNAVAILABLE",
  // --- food photo (C10) ---------------------------------------------------
  /**
   * Today's food-photo meter is full → the food tab is closed until tomorrow.
   *
   * Separate from `PHOTO_DAILY_LIMIT_REACHED` because the two meters are separate: collapsing
   * them would send a user whose scan meter is full to a "come back tomorrow" screen on a tab
   * that is, in fact, still open.
   */
  FOOD_DAILY_LIMIT_REACHED: "FOOD_DAILY_LIMIT_REACHED",
  /** Vision AI saw no dish in the photo → scan rejected, no reward. */
  FOOD_NOT_RECOGNISED: "FOOD_NOT_RECOGNISED",
  // --- referral -----------------------------------------------------------
  REFERRAL_SELF_NOT_ALLOWED: "REFERRAL_SELF_NOT_ALLOWED",
  REFERRAL_ALREADY_SET: "REFERRAL_ALREADY_SET",
  REFERRAL_WEEKLY_TICKET_CAP_REACHED: "REFERRAL_WEEKLY_TICKET_CAP_REACHED",
  // --- sovg'aga almashtirish (P8.1) ---------------------------------------
  /** Katalogda bunday band yo'q, yoki u o'chirilgan. */
  REWARD_NOT_FOUND: "REWARD_NOT_FOUND",
  /**
   * Band `active = false` ga o'tgan. `REWARD_NOT_FOUND` dan ajratilgan: ro'yxat ochiq turganda
   * admin bandni yashirsa, foydalanuvchi ko'rib turgan narsani "topilmadi" deb aytish yolg'on —
   * u BOR, endi berilmaydi.
   */
  REWARD_INACTIVE: "REWARD_INACTIVE",
  /**
   * Ball yetmaydi. `details` da `required` va `balance` keladi, ya'ni ekran raqamni o'zi
   * hisoblamaydi — balans boshqa qurilmada o'zgargan bo'lishi mumkin.
   */
  REWARD_INSUFFICIENT_POINTS: "REWARD_INSUFFICIENT_POINTS",
  /**
   * Buyurtma bu holatdan bunday o'tolmaydi (masalan allaqachon bekor qilingan buyurtmani
   * yetkazish). Ikki admin bitta navbat ustida ishlaganda paydo bo'ladi.
   */
  REWARD_REDEMPTION_INVALID_STATE: "REWARD_REDEMPTION_INVALID_STATE",
  /**
   * Katalog bandini o'chirib bo'lmaydi — unga bog'langan buyurtmalar bor. O'chirish tarixni
   * ham olib ketardi, holbuki tarix aynan pul harakatining izohi. Yechim — bandni yashirish.
   */
  REWARD_HAS_REDEMPTIONS: "REWARD_HAS_REDEMPTIONS",
  // --- draws --------------------------------------------------------------
  DRAW_NOT_FOUND: "DRAW_NOT_FOUND",
  DRAW_ALREADY_COMPLETED: "DRAW_ALREADY_COMPLETED",
  DRAW_NO_ELIGIBLE_TICKETS: "DRAW_NO_ELIGIBLE_TICKETS",
  /**
   * The chosen ticket left the game between being read and being crowned (an admin revoke landing
   * mid-broadcast). Distinct from `DRAW_NO_ELIGIBLE_TICKETS` on purpose: the draw had plenty of
   * entrants, so telling the operator "no eligible tickets" mid-stream would send them looking in
   * the wrong place.
   */
  DRAW_WINNER_CHANGED: "DRAW_WINNER_CHANGED",
  /** A reveal was attempted on a draw that has not been run (or was postponed). */
  DRAW_NOT_COMPLETED: "DRAW_NOT_COMPLETED",
  /**
   * The entrant count or the winner has already been announced for this draw. Both carry a fact
   * and may go out once; a shortlist may repeat as the presenter narrows the field.
   */
  DRAW_STEP_ALREADY_REVEALED: "DRAW_STEP_ALREADY_REVEALED",
  /** The presenter attempted a live step before its required predecessor was complete. */
  DRAW_REVEAL_OUT_OF_ORDER: "DRAW_REVEAL_OUT_OF_ORDER",
  /** Another presenter advanced the draw after this console rendered it. */
  DRAW_REVEAL_STATE_STALE: "DRAW_REVEAL_STATE_STALE",
  /** Every character of the winning ticket code is already visible. */
  DRAW_SHORTLIST_COMPLETE: "DRAW_SHORTLIST_COMPLETE",
  /**
   * G'oliblar e'loni butun bazaga ketadigan xabar, ya'ni qaytarib bo'lmaydi — shuning uchun u
   * efir marosimi TUGAGANDAN keyingina ochiladi. Efirda hali e'lon qilinmagan g'olib bo'lsa,
   * xabar tomoshabin ekranda ko'rmagan natijani aytib qo'yardi.
   */
  DRAW_WINNERS_NOT_REVEALED: "DRAW_WINNERS_NOT_REVEALED",
  /** Bu efirning g'oliblari allaqachon e'lon qilingan — ikkinchi marta yuborilmaydi. */
  DRAW_WINNERS_ALREADY_ANNOUNCED: "DRAW_WINNERS_ALREADY_ANNOUNCED",
  /** Efir mini appdan yashirilgan (`live_enabled = false`) — undan hech qanday push chiqmaydi. */
  DRAW_LIVE_DISABLED: "DRAW_LIVE_DISABLED",
  /**
   * Oylik efir jadvalga qo'yilmagan va o'tkazish so'rovida ham sovrin nomi yo'q.
   *
   * Ilgari `prizeLabel` majburiy edi va o'tkazish bosqichi uni jadvaldagi qiymat ustiga yozardi —
   * ya'ni bitta so'rov e'lon qilingan sovrinni jimgina almashtira olardi. Endi sovrinning yagona
   * egasi `POST /admin/draws/schedule`, va bu xato aynan bitta holatda chiqadi: efir umuman
   * jadvalga qo'yilmagan, ya'ni yozadigan nom hech qayerdan kelmayapti.
   */
  DRAW_PRIZE_LABEL_REQUIRED: "DRAW_PRIZE_LABEL_REQUIRED",
  // --- internal / infra ---------------------------------------------------
  /** Bad or missing HMAC signature on an internal (scraper → api) call. */
  INTERNAL_SIGNATURE_INVALID: "INTERNAL_SIGNATURE_INVALID",
  /** Signature was valid but the timestamp is outside the allowed skew (replay). */
  INTERNAL_SIGNATURE_EXPIRED: "INTERNAL_SIGNATURE_EXPIRED",
  // --- generic ------------------------------------------------------------
  RATE_LIMITED: "RATE_LIMITED",
  TEMPORARILY_BLOCKED: "TEMPORARILY_BLOCKED",
  IDEMPOTENCY_KEY_REUSED: "IDEMPOTENCY_KEY_REUSED",
  NOT_FOUND: "NOT_FOUND",
  VALIDATION_FAILED: "VALIDATION_FAILED",
  INTERNAL_ERROR: "INTERNAL_ERROR"
};
var ERROR_SCREEN = {
  [ErrorCode.RECEIPT_INVALID_ORIGIN]: "C5",
  [ErrorCode.RECEIPT_INVALID_QR]: "C5",
  [ErrorCode.RECEIPT_TOO_OLD]: "C5",
  [ErrorCode.RECEIPT_DUPLICATE]: "C4",
  [ErrorCode.PHOTO_DAILY_LIMIT_REACHED]: "C6",
  [ErrorCode.PHOTO_NO_ITEMS_RECOGNISED]: "C8",
  [ErrorCode.PHOTO_NO_ITEMS_CONFIRMED]: "C8",
  // C7, not C8: recognition never produced a list, so there is nothing to review — the client
  // stays on the capture step and retries the same upload.
  [ErrorCode.VISION_UNAVAILABLE]: "C7",
  [ErrorCode.FOOD_DAILY_LIMIT_REACHED]: "C10",
  [ErrorCode.FOOD_NOT_RECOGNISED]: "C10"
};

// src/time.ts
var SystemClock = class {
  now() {
    return new Date(Date.now());
  }
};
var FixedClock = class {
  constructor(current) {
    this.current = current;
  }
  current;
  now() {
    return new Date(this.current.getTime());
  }
  set(next) {
    this.current = next;
  }
  advance(ms) {
    this.current = new Date(this.current.getTime() + ms);
  }
};
var ISO_WEEKDAY_BY_NAME = {
  Mon: 1,
  Tue: 2,
  Wed: 3,
  Thu: 4,
  Fri: 5,
  Sat: 6,
  Sun: 7
};
var formatterCache = /* @__PURE__ */ new Map();
function formatterFor(timeZone) {
  let formatter = formatterCache.get(timeZone);
  if (!formatter) {
    formatter = new Intl.DateTimeFormat("en-US", {
      timeZone,
      hourCycle: "h23",
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
      weekday: "short"
    });
    formatterCache.set(timeZone, formatter);
  }
  return formatter;
}
function getZonedParts(instant, timeZone = TIMEZONE) {
  const parts = formatterFor(timeZone).formatToParts(instant);
  const lookup = {};
  for (const part of parts) {
    if (part.type !== "literal") lookup[part.type] = part.value;
  }
  return {
    year: Number(lookup.year),
    month: Number(lookup.month),
    day: Number(lookup.day),
    hour: Number(lookup.hour),
    minute: Number(lookup.minute),
    second: Number(lookup.second),
    isoWeekday: ISO_WEEKDAY_BY_NAME[lookup.weekday ?? "Mon"] ?? 1
  };
}
function zoneOffsetMs(instant, timeZone = TIMEZONE) {
  const p = getZonedParts(instant, timeZone);
  const asIfUtc = Date.UTC(p.year, p.month - 1, p.day, p.hour, p.minute, p.second);
  const flooredToSecond = Math.floor(instant.getTime() / 1e3) * 1e3;
  return asIfUtc - flooredToSecond;
}
function zonedTimeToUtc(parts, timeZone = TIMEZONE) {
  const naive = Date.UTC(
    parts.year,
    parts.month - 1,
    parts.day,
    parts.hour ?? 0,
    parts.minute ?? 0,
    parts.second ?? 0
  );
  let instant = naive - zoneOffsetMs(new Date(naive), timeZone);
  instant = naive - zoneOffsetMs(new Date(instant), timeZone);
  return new Date(instant);
}
var pad = (value, width = 2) => String(value).padStart(width, "0");
function dayKey(instant, timeZone = TIMEZONE) {
  const p = getZonedParts(instant, timeZone);
  return `${pad(p.year, 4)}-${pad(p.month)}-${pad(p.day)}`;
}
function monthKey(instant, timeZone = TIMEZONE) {
  const p = getZonedParts(instant, timeZone);
  return `${pad(p.year, 4)}-${pad(p.month)}`;
}
function dayKeyToInstant(key, timeZone = TIMEZONE) {
  const match = /^(\d{4})-(\d{2})-(\d{2})$/.exec(key);
  if (!match) throw new TypeError(`Invalid day key: ${key}`);
  return zonedTimeToUtc(
    { year: Number(match[1]), month: Number(match[2]), day: Number(match[3]) },
    timeZone
  );
}
function startOfDay(instant, timeZone = TIMEZONE) {
  const p = getZonedParts(instant, timeZone);
  return zonedTimeToUtc({ year: p.year, month: p.month, day: p.day }, timeZone);
}
function startOfNextDay(instant, timeZone = TIMEZONE) {
  return addLocalDays(startOfDay(instant, timeZone), 1, timeZone);
}
function addLocalDays(instant, days, timeZone = TIMEZONE) {
  const p = getZonedParts(instant, timeZone);
  return zonedTimeToUtc(
    {
      year: p.year,
      month: p.month,
      day: p.day + days,
      hour: p.hour,
      minute: p.minute,
      second: p.second
    },
    timeZone
  );
}
function startOfWeek(instant, timeZone = TIMEZONE) {
  const p = getZonedParts(instant, timeZone);
  const daysSinceWeekStart = (p.isoWeekday - WEEK_START_ISO_WEEKDAY + 7) % 7;
  return zonedTimeToUtc(
    { year: p.year, month: p.month, day: p.day - daysSinceWeekStart },
    timeZone
  );
}
function startOfNextWeek(instant, timeZone = TIMEZONE) {
  return addLocalDays(startOfWeek(instant, timeZone), 7, timeZone);
}
function weekKey(instant, timeZone = TIMEZONE) {
  return dayKey(startOfWeek(instant, timeZone), timeZone);
}
function weekKeyToInstant(key, timeZone = TIMEZONE) {
  return startOfWeek(dayKeyToInstant(key, timeZone), timeZone);
}
function weekEndDayKey(key, timeZone = TIMEZONE) {
  return dayKey(addLocalDays(weekKeyToInstant(key, timeZone), 6, timeZone), timeZone);
}
function previousWeekKey(key, timeZone = TIMEZONE) {
  return dayKey(addLocalDays(weekKeyToInstant(key, timeZone), -7, timeZone), timeZone);
}
function startOfMonth(instant, timeZone = TIMEZONE) {
  const p = getZonedParts(instant, timeZone);
  return zonedTimeToUtc({ year: p.year, month: p.month, day: 1 }, timeZone);
}
function startOfNextMonth(instant, timeZone = TIMEZONE) {
  const p = getZonedParts(instant, timeZone);
  return zonedTimeToUtc({ year: p.year, month: p.month + 1, day: 1 }, timeZone);
}
function monthKeyToInstant(key, timeZone = TIMEZONE) {
  const match = /^(\d{4})-(\d{2})$/.exec(key);
  if (!match) throw new TypeError(`Invalid month key: ${key}`);
  return zonedTimeToUtc({ year: Number(match[1]), month: Number(match[2]), day: 1 }, timeZone);
}
function previousMonthKey(key, timeZone = TIMEZONE) {
  const start = monthKeyToInstant(key, timeZone);
  return monthKey(new Date(start.getTime() - 1), timeZone);
}
function calendarDaysBetween(earlier, later, timeZone = TIMEZONE) {
  const a = startOfDay(earlier, timeZone).getTime();
  const b = startOfDay(later, timeZone).getTime();
  return Math.round((b - a) / 864e5);
}

// src/rewards.ts
function hasDailyTicketCapacity(dailyScanTicketCount) {
  return dailyScanTicketCount < DAILY_SCAN_TICKET_LIMIT;
}
function isWithinWeeklyReceiptLimit(weeklyReceiptCount) {
  return weeklyReceiptCount < WEEKLY_RECEIPT_LIMIT;
}
function percentagePoints(totalAmount) {
  return Math.floor(totalAmount * RECEIPT_POINTS_RATE);
}
function decideReceiptScan(input) {
  const { weeklyReceiptCount, dailyScanTicketCount } = input;
  if (isWithinWeeklyReceiptLimit(weeklyReceiptCount)) {
    const grantsTicket = hasDailyTicketCapacity(dailyScanTicketCount);
    return {
      accepted: true,
      ticketCount: grantsTicket ? TICKETS_PER_RECEIPT : 0,
      outcome: grantsTicket ? ReceiptScanOutcome.FULL_REWARD : ReceiptScanOutcome.POINTS_ONLY
    };
  }
  return {
    accepted: true,
    ticketCount: 0,
    outcome: ReceiptScanOutcome.OVER_LIMIT_FIXED
  };
}
function receiptPointsForTotal(totalAmount, outcome) {
  if (outcome !== ReceiptScanOutcome.OVER_LIMIT_FIXED) return percentagePoints(totalAmount);
  return isWithinOverLimitBand(totalAmount) ? OVER_LIMIT_RECEIPT_POINTS : 0;
}
function canStartPhotoScan(dailyScanTicketCount) {
  return hasDailyTicketCapacity(dailyScanTicketCount);
}
function decidePhotoReward(input) {
  const { confirmedItemCount, dailyScanTicketCount } = input;
  if (confirmedItemCount < PHOTO_MIN_CONFIRMED_ITEMS) {
    return { accepted: false, code: ErrorCode.PHOTO_NO_ITEMS_CONFIRMED };
  }
  const grantsTicket = hasDailyTicketCapacity(dailyScanTicketCount);
  return {
    accepted: true,
    points: PHOTO_POINTS,
    ticketCount: grantsTicket ? TICKETS_PER_PHOTO : 0,
    outcome: grantsTicket ? PhotoScanOutcome.FULL_REWARD : PhotoScanOutcome.POINTS_ONLY
  };
}
function hasDailyFoodCapacity(dailyFoodTicketCount) {
  return dailyFoodTicketCount < DAILY_FOOD_PHOTO_LIMIT;
}
function canStartFoodScan(dailyFoodTicketCount) {
  return hasDailyFoodCapacity(dailyFoodTicketCount);
}
function decideFoodReward(input) {
  const { confirmedItemCount, dailyFoodTicketCount } = input;
  if (confirmedItemCount < PHOTO_MIN_CONFIRMED_ITEMS) {
    return { accepted: false, code: ErrorCode.PHOTO_NO_ITEMS_CONFIRMED };
  }
  const grantsTicket = hasDailyFoodCapacity(dailyFoodTicketCount);
  return {
    accepted: true,
    points: FOOD_POINTS,
    ticketCount: grantsTicket ? TICKETS_PER_FOOD : 0,
    outcome: grantsTicket ? PhotoScanOutcome.FULL_REWARD : PhotoScanOutcome.POINTS_ONLY
  };
}
function isReceiptFresh(issuedAt, now) {
  const ageDays = calendarDaysBetween(issuedAt, now);
  return ageDays >= 0 && ageDays <= RECEIPT_MAX_AGE_DAYS;
}
function referralTicketsToGrant(weeklyReferralTicketCount) {
  const remaining = WEEKLY_REFERRAL_TICKET_CAP - weeklyReferralTicketCount;
  if (remaining <= 0) return 0;
  return Math.min(REFERRAL_TICKETS, remaining);
}
function isWithinOverLimitBand(totalAmount) {
  return totalAmount >= OVER_LIMIT_RECEIPT_MIN_TOTAL && totalAmount <= OVER_LIMIT_RECEIPT_MAX_TOTAL;
}

// src/tickets.ts
function expectedTicketStatus(ticket, context) {
  if (TERMINAL_TICKET_STATUSES.includes(ticket.status)) return ticket.status;
  if (ticket.status === TicketStatus.FRAUD_REVIEW) return TicketStatus.FRAUD_REVIEW;
  if (context.completedMonthlyDraws.has(ticket.monthKey)) return TicketStatus.FINISHED;
  if (ticket.dailyDrawDate === null) {
    return ticket.status === TicketStatus.PENDING_DAILY ? TicketStatus.PENDING_DAILY : ticket.status;
  }
  if (ticket.dailyDrawDate === dayKey(context.now)) return TicketStatus.PLAYED_DAILY;
  const playedAt = dayKeyToInstant(ticket.dailyDrawDate);
  const weekIsOver = context.now.getTime() >= startOfNextWeek(playedAt).getTime();
  return weekIsOver ? TicketStatus.IN_MONTHLY_POOL : TicketStatus.IN_WEEKLY_POOL;
}
function maskedTicketStatus(ticket, context) {
  return expectedTicketStatus({ ...ticket, status: TicketStatus.PLAYED_DAILY }, context);
}

// src/telegram-html.ts
var TELEGRAM_HTML_TAGS = [
  "b",
  "strong",
  "i",
  "em",
  "u",
  "ins",
  "s",
  "strike",
  "del",
  "span",
  "tg-spoiler",
  "a",
  "code",
  "pre",
  "blockquote"
];
var TAG_SET = new Set(TELEGRAM_HTML_TAGS);
function escapeTelegramHtml(value) {
  return value.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;");
}
var TAG_PATTERN = /<\/?([a-zA-Z][a-zA-Z0-9-]*)(\s[^>]*)?>/g;
function findTelegramHtmlProblems(html) {
  const problems = [];
  const open = [];
  for (const match of html.matchAll(TAG_PATTERN)) {
    const [whole, rawName] = match;
    const tag = rawName.toLowerCase();
    if (!TAG_SET.has(tag)) {
      problems.push({ kind: "unknown_tag", tag });
      continue;
    }
    if (whole.startsWith("</")) {
      if (open.pop() !== tag) problems.push({ kind: "stray_close", tag });
      continue;
    }
    if (tag === "a" && !hasUsableHref(whole)) {
      problems.push({ kind: "bad_link", tag });
    }
    open.push(tag);
  }
  for (const tag of open) problems.push({ kind: "unclosed_tag", tag });
  return problems;
}
function hasUsableHref(openTag) {
  const href = /href\s*=\s*"([^"]*)"|href\s*=\s*'([^']*)'/i.exec(openTag);
  const value = href?.[1] ?? href?.[2];
  if (!value) return false;
  return /^(https?:\/\/|tg:\/\/)/i.test(value);
}
function isValidTelegramHtml(html) {
  return findTelegramHtmlProblems(html).length === 0;
}

// src/sentry-scrub.ts
var SENTRY_REDACTED = "[redacted]";
var SENSITIVE_KEYS = /* @__PURE__ */ new Set([
  // Kirish huquqini beradigan narsalar
  "authorization",
  "cookie",
  "setcookie",
  "token",
  "accesstoken",
  "refreshtoken",
  "idtoken",
  "jwt",
  "password",
  "secret",
  "apikey",
  // Telegram
  "initdata",
  "telegraminitdata",
  "xtelegrambotapisecrettoken",
  "hash",
  // Ichki HMAC (§4.6) — `x-qaytim-signature` va `x-qaytim-timestamp`
  "signature",
  "xqaytimsignature",
  // Shaxsga doir
  "phone",
  "phonenumber",
  "email"
]);
var INITDATA_TOKEN_PATTERN = /\S*hash=[a-f0-9]{16,}\S*/gi;
var INITDATA_COMPANION = /(auth_date|query_id|user)=/;
var JWT_PATTERN = /\beyJ[A-Za-z0-9_-]{8,}\.[A-Za-z0-9_-]{8,}\.[A-Za-z0-9_-]{8,}\b/g;
var BEARER_PATTERN = /\bBearer\s+[A-Za-z0-9._~+/=-]{8,}/gi;
var PHONE_PATTERN = /\+?998[\s()-]*\d{2}[\s-]*\d{3}[\s-]*\d{2}[\s-]*\d{2}|\+\d{10,15}\b/g;
var QUERY_PARAM_PATTERN = /([?&](?:token|access_?token|refresh_?token|init_?data|signature|password|secret|api_?key|phone(?:_?number)?)=)[^&#\s]*/gi;
function isSensitiveKey(key) {
  return SENSITIVE_KEYS.has(key.toLowerCase().replace(/[-_]/g, ""));
}
function scrubSentryString(value) {
  return value.replace(
    INITDATA_TOKEN_PATTERN,
    (token) => INITDATA_COMPANION.test(token) ? SENTRY_REDACTED : token
  ).replace(QUERY_PARAM_PATTERN, `$1${SENTRY_REDACTED}`).replace(JWT_PATTERN, SENTRY_REDACTED).replace(BEARER_PATTERN, `Bearer ${SENTRY_REDACTED}`).replace(PHONE_PATTERN, SENTRY_REDACTED);
}
var MAX_DEPTH = 12;
function isPlainObject(value) {
  const prototype = Object.getPrototypeOf(value);
  return prototype === Object.prototype || prototype === null;
}
function scrubValue(value, depth, seen) {
  if (typeof value === "string") return scrubSentryString(value);
  if (value === null || typeof value !== "object") return value;
  if (depth >= MAX_DEPTH) return value;
  const isArray = Array.isArray(value);
  if (!isArray && !isPlainObject(value)) return value;
  if (seen.has(value)) return SENTRY_REDACTED;
  seen.add(value);
  if (isArray) return value.map((item) => scrubValue(item, depth + 1, seen));
  const result = {};
  for (const [key, item] of Object.entries(value)) {
    result[key] = isSensitiveKey(key) ? SENTRY_REDACTED : scrubValue(item, depth + 1, seen);
  }
  return result;
}
function scrubSentryEvent(event) {
  return scrubValue(event, 0, /* @__PURE__ */ new WeakSet());
}

// src/contracts/common.ts
import { z } from "zod";
var idSchema = z.string().uuid();
var dayKeySchema = z.string().regex(/^\d{4}-\d{2}-\d{2}$/, "Expected YYYY-MM-DD");
var monthKeySchema = z.string().regex(/^\d{4}-\d{2}$/, "Expected YYYY-MM");
var isoDateTimeSchema = z.string().datetime({ offset: true });
var somSchema = z.number().int().nonnegative();
var pointsSchema = z.number().int();
var paginationQuerySchema = z.object({
  /** Opaque cursor = the previous page's last id. */
  cursor: idSchema.optional(),
  limit: z.coerce.number().int().min(1).max(100).default(20)
});
var ADMIN_PAGE_SIZES = [10, 20, 50, 100];
var offsetPaginationQuerySchema = z.object({
  page: z.coerce.number().int().min(1).default(1),
  limit: z.coerce.number().int().min(1).max(100).default(20)
});
var errorBodySchema = z.object({
  code: z.string(),
  message: z.string(),
  details: z.record(z.unknown()).optional()
});
var meterSchema = z.object({
  used: z.number().int().nonnegative(),
  limit: z.number().int().positive(),
  /** When the window rolls over, so the UI can say "ertaga". */
  resetsAt: isoDateTimeSchema
});
var limitsSchema = z.object({
  /** Shared receipts+product-photos ticket meter for today (5/day). */
  dailyScanTickets: meterSchema,
  /** Food photos rewarded today (3/day) — its OWN meter, not a slice of the scan one. */
  dailyFoodPhotos: meterSchema,
  /** Receipts this week that still earn the percentage reward (20/week). */
  weeklyReceipts: meterSchema,
  /** Referral tickets received this week (50/week cap). */
  weeklyReferralTickets: meterSchema
});
function paginated(item) {
  return z.object({
    items: z.array(item),
    nextCursor: idSchema.nullable()
  });
}
function offsetPaginated(item) {
  return z.object({
    items: z.array(item),
    total: z.number().int().nonnegative(),
    page: z.number().int().positive(),
    limit: z.number().int().positive(),
    pageCount: z.number().int().nonnegative()
  });
}
function toOffsetPage(items, total, query) {
  return {
    items,
    total,
    page: query.page,
    limit: query.limit,
    pageCount: Math.ceil(total / query.limit)
  };
}

// src/contracts/auth.ts
import { z as z2 } from "zod";
var telegramLoginRequestSchema = z2.object({
  initData: z2.string().min(1),
  /** `ref_<user_id>` captured from the bot start parameter, if any. */
  startParam: z2.string().max(128).optional()
});
var authUserSchema = z2.object({
  id: idSchema,
  telegramId: z2.string(),
  firstName: z2.string().nullable(),
  username: z2.string().nullable(),
  languageCode: z2.string().nullable(),
  currentBalance: z2.number().int(),
  /** Botdagi `request_contact` orqali tasdiqlangan raqam; null — hali ulashilmagan (P5.1). */
  phoneNumber: z2.string().nullable(),
  /**
   * `true` — ommaviy xabarlardan (efir eslatmasi, g'oliblar e'loni) voz kechilgan.
   *
   * SHAXSIY xabarlarga taalluqli emas: chek bekor qilinishi, ball tushishi va o'z yutug'i
   * baribir boradi. Ular foydalanuvchining O'Z hisobidagi hodisalar — ularni "obuna" deb
   * hisoblash xabarni emas, hisobning o'zini ko'rinmas qilib qo'yardi.
   */
  broadcastOptOut: z2.boolean(),
  createdAt: isoDateTimeSchema
});
var authTokensSchema = z2.object({
  accessToken: z2.string(),
  refreshToken: z2.string(),
  /** Seconds until the access token expires — the client refreshes slightly before. */
  expiresIn: z2.number().int().positive()
});
var authSessionSchema = authTokensSchema.extend({ user: authUserSchema });
var refreshRequestSchema = z2.object({ refreshToken: z2.string().min(1) });
var logoutRequestSchema = refreshRequestSchema;
var accessTokenClaimsSchema = z2.object({
  sub: idSchema,
  typ: z2.literal("user")
});
var adminLoginRequestSchema = z2.object({
  // Normallashtirish TEKSHIRUVDAN oldin: forma avtomatik bosh harf qo'ygan yoki nusxa olishda
  // bo'sh joy qo'shilgan email "noto'g'ri parol" bo'lib qaytmasligi kerak.
  //
  // Yuqori chegaralar shuning uchunki: email muvaffaqiyatsiz urinish yozuvida saqlanadi va parol
  // argon2 ga uzatiladi — ikkalasi ham chegarasiz kirish qiymatini qabul qilmasligi kerak.
  email: z2.string().trim().toLowerCase().email().max(320),
  password: z2.string().min(8).max(200)
});
var AdminRole = { ADMIN: "admin", OPERATOR: "operator" };
var adminTokenClaimsSchema = z2.object({
  sub: idSchema,
  typ: z2.literal("admin"),
  role: z2.enum([AdminRole.ADMIN, AdminRole.OPERATOR])
});
var broadcastOverlayTokenClaimsSchema = z2.object({
  sub: idSchema,
  typ: z2.literal("broadcast_overlay"),
  /** Random credential id; only its SHA-256 hash is persisted. */
  jti: z2.string().min(32)
});
var adminAccountSchema = z2.object({
  id: idSchema,
  email: z2.string().email(),
  role: z2.enum([AdminRole.ADMIN, AdminRole.OPERATOR])
});
var adminSessionSchema = z2.object({
  accessToken: z2.string(),
  expiresIn: z2.number().int().positive(),
  admin: adminAccountSchema
});

// src/contracts/receipts.ts
import { z as z3 } from "zod";
var receiptStatusSchema = z3.enum([
  ReceiptStatus.PENDING_DETAILS,
  ReceiptStatus.DETAILS_FETCHING,
  ReceiptStatus.DETAILS_READY,
  ReceiptStatus.DETAILS_FAILED
]);
var receiptScanOutcomeSchema = z3.enum([
  ReceiptScanOutcome.FULL_REWARD,
  ReceiptScanOutcome.POINTS_ONLY,
  ReceiptScanOutcome.OVER_LIMIT_FIXED
]);
var receiptScanRequestSchema = z3.object({
  qrRaw: z3.string().min(1).max(2048)
});
var receiptItemSchema = z3.object({
  id: idSchema,
  name: z3.string(),
  price: somSchema,
  quantity: z3.number().nonnegative()
});
var receiptScanResponseSchema = z3.object({
  receiptId: idSchema,
  outcome: receiptScanOutcomeSchema,
  /**
   * ALWAYS null at scan time since P6.1: the QR carries no total, so points are computed and
   * credited only when the scraper reads the real sum off the receipt page (`details_ready`).
   * Kept in the contract (rather than dropped) so the history/detail schemas share the field.
   */
  pointsAwarded: z3.number().int().nonnegative().nullable(),
  /** Null when no ticket was granted (daily limit full, or over-weekly-limit receipt). */
  ticketId: idSchema.nullable(),
  /** Null until the scraper confirms it — the QR does not contain the sum. */
  totalAmount: somSchema.nullable(),
  issuedAt: isoDateTimeSchema,
  /** Current balance (unchanged by the scan itself — points arrive with the details). */
  balanceAfter: z3.number().int(),
  /** Fresh meters so B2/C3 render without another round-trip. */
  limits: limitsSchema
});
var receiptSummarySchema = z3.object({
  id: idSchema,
  status: receiptStatusSchema,
  /** Null while details are pending — E2/E3 show "hisoblanmoqda" (P6.1). */
  totalAmount: somSchema.nullable(),
  issuedAt: isoDateTimeSchema,
  scannedAt: isoDateTimeSchema,
  /** Null while details are pending; final once `details_ready` (or the receipt is revoked). */
  pointsAwarded: z3.number().int().nullable(),
  ticketId: idSchema.nullable(),
  /** True once the receipt has been cancelled (details_failed outside degraded mode). */
  revoked: z3.boolean()
});
var receiptDetailSchema = receiptSummarySchema.extend({
  merchantName: z3.string().nullable(),
  items: z3.array(receiptItemSchema),
  /**
   * The human ticket code (`QT-…`), null when the scan granted no ticket.
   *
   * TZ §3.5 asks E2 to show the ticket NUMBER and link to D2 — both, not just the link. `ticketId`
   * is a UUID and belongs to no screen: it is the routing key, not something a person can read
   * off their list or repeat over the phone.
   */
  ticketCode: z3.string().nullable()
});
var receiptListResponseSchema = paginated(receiptSummarySchema);

// src/contracts/photos.ts
import { z as z4 } from "zod";
var photoSubjectSchema = z4.enum([PhotoSubject.PRODUCT, PhotoSubject.FOOD]);
var photoScanStatusSchema = z4.enum([
  PhotoScanStatus.AWAITING_UPLOAD,
  PhotoScanStatus.IN_REVIEW,
  PhotoScanStatus.CONFIRMED,
  PhotoScanStatus.REJECTED,
  PhotoScanStatus.VOID
]);
var photoScanOutcomeSchema = z4.enum([
  PhotoScanOutcome.FULL_REWARD,
  PhotoScanOutcome.POINTS_ONLY
]);
var photoUploadUrlRequestSchema = z4.object({
  contentType: z4.enum(PHOTO_ALLOWED_MIME_TYPES),
  contentLength: z4.number().int().positive().max(PHOTO_MAX_UPLOAD_BYTES),
  /** C10 — which meter is checked here and which reward the confirm pays. */
  subject: photoSubjectSchema.default(PhotoSubject.PRODUCT)
});
var photoUploadUrlResponseSchema = z4.object({
  photoScanId: idSchema,
  /** Client PUTs the bytes straight here — the API never proxies image data. */
  uploadUrl: z4.string().url(),
  /** Headers the client must replay on the PUT for the signature to match. */
  uploadHeaders: z4.record(z4.string()).default({}),
  storageKey: z4.string(),
  expiresAt: isoDateTimeSchema
});
var photoScanRequestSchema = z4.object({
  storageKey: z4.string().min(1)
});
var photoItemSchema = z4.object({
  id: idSchema,
  name: z4.string().min(1).max(PHOTO_ITEM_NAME_MAX_LENGTH),
  confidence: z4.number().min(0).max(1).nullable(),
  /** False once the user deletes it on C8. */
  confirmed: z4.boolean(),
  /** True when the user corrected the AI's name — feeds the recognition-accuracy metric. */
  edited: z4.boolean()
});
var photoScanResponseSchema = z4.object({
  photoScanId: idSchema,
  status: photoScanStatusSchema,
  subject: photoSubjectSchema,
  items: z4.array(photoItemSchema)
});
var photoReviewRequestSchema = z4.object({
  items: z4.array(
    z4.object({
      id: idSchema,
      /** Corrected name; omit to keep the AI's. */
      name: z4.string().min(1).max(PHOTO_ITEM_NAME_MAX_LENGTH).optional(),
      /** false = user removed this item. */
      confirmed: z4.boolean()
    })
  )
});
var photoConfirmResponseSchema = z4.object({
  photoScanId: idSchema,
  outcome: photoScanOutcomeSchema,
  pointsAwarded: z4.number().int().nonnegative(),
  ticketId: idSchema.nullable(),
  balanceAfter: z4.number().int(),
  limits: limitsSchema
});
var photoScanSummarySchema = z4.object({
  id: idSchema,
  status: photoScanStatusSchema,
  /** Product photo or food photo — E1 labels the row from this. */
  subject: photoSubjectSchema,
  createdAt: isoDateTimeSchema,
  pointsAwarded: z4.number().int(),
  ticketId: idSchema.nullable(),
  itemCount: z4.number().int().nonnegative()
});
var photoScanDetailSchema = photoScanSummarySchema.extend({
  items: z4.array(photoItemSchema),
  /** Short-lived read URL, or null when storage is unavailable. */
  imageUrl: z4.string().url().nullable(),
  /**
   * The human ticket code (`QT-…`), null when the scan granted no ticket. TZ §3.5 asks E3 for the
   * ticket NUMBER as well as the link to D2; `ticketId` is a UUID and is only the routing key.
   */
  ticketCode: z4.string().nullable()
});
var photoScanListResponseSchema = paginated(photoScanSummarySchema);

// src/contracts/tickets.ts
import { z as z5 } from "zod";
var ticketStatusSchema = z5.enum([
  TicketStatus.PENDING_DAILY,
  TicketStatus.PLAYED_DAILY,
  TicketStatus.IN_WEEKLY_POOL,
  TicketStatus.IN_MONTHLY_POOL,
  TicketStatus.FINISHED,
  TicketStatus.WON,
  TicketStatus.REVOKED,
  TicketStatus.FRAUD_REVIEW
]);
var ticketSourceSchema = z5.enum([
  TicketSource.RECEIPT,
  TicketSource.PHOTO,
  TicketSource.FOOD,
  TicketSource.REFERRAL,
  TicketSource.ADMIN
]);
var ticketSchema = z5.object({
  id: idSchema,
  /** Short human-readable code shown on D2/D3 (e.g. `QT-8F3K2`). */
  code: z5.string(),
  status: ticketStatusSchema,
  source: ticketSourceSchema,
  /** Asia/Tashkent calendar day the ticket belongs to. */
  acquiredDate: dayKeySchema,
  /** Calendar month that decides which monthly draw it plays in. */
  monthKey: monthKeySchema,
  createdAt: isoDateTimeSchema,
  /**
   * Set ONLY when the ticket has actually played a daily draw — never when one is merely
   * scheduled. The lifecycle reads `dailyDrawDate !== null` as "has played", and the whole
   * postponement guarantee rests on it (implementation-plan §3.6.5: on a day with no broadcast the
   * tickets STAY in `pending_daily`). Pre-stamping this when a draw is scheduled would march
   * tickets through the pools for a draw that never ran.
   */
  dailyDrawDate: dayKeySchema.nullable(),
  /** Populated only for `won`. */
  wonDrawId: idSchema.nullable()
});
var ticketListResponseSchema = paginated(ticketSchema);
var ticketCountsSchema = z5.object({
  total: z5.number().int().nonnegative(),
  /** Playing in tomorrow's daily draw. */
  pendingDaily: z5.number().int().nonnegative(),
  inWeeklyPool: z5.number().int().nonnegative(),
  inMonthlyPool: z5.number().int().nonnegative(),
  won: z5.number().int().nonnegative()
});

// src/contracts/draws.ts
import { z as z6 } from "zod";
var drawTypeSchema = z6.enum([DrawType.DAILY, DrawType.WEEKLY, DrawType.MONTHLY]);
var drawStatusSchema = z6.enum([
  DrawStatus.SCHEDULED,
  DrawStatus.COMPLETED,
  DrawStatus.POSTPONED
]);
var drawSchema = z6.object({
  id: idSchema,
  type: drawTypeSchema,
  status: drawStatusSchema,
  /**
   * Kunlik va HAFTALIK efir kun bilan, oylik efir oy bilan kalitlanadi; ikkinchisi `null`.
   *
   * Haftalik efirda bu sana — o'sha haftaning DUSHANBASI, efir kuni emas (efirning o'zi hafta
   * yopilgach bo'lib o'tadi va uning vaqti `scheduledAt` da).
   */
  drawDate: dayKeySchema.nullable(),
  monthKey: monthKeySchema.nullable(),
  scheduledAt: isoDateTimeSchema,
  completedAt: isoDateTimeSchema.nullable(),
  /**
   * Free-text prize label — soʻm amount for daily, item name for monthly.
   *
   * Ko'p sovrinli efirda bu maydon `prizes` ning O'RNINI BOSMAYDI, balki uning yig'masi bo'lib
   * qoladi (kartadagi bitta qatorlik matn). Kim nimani yutgani `winners[].prizeLabel` da.
   */
  prizeLabel: z6.string(),
  /**
   * E'lon qilingan sovrinlar — har bir g'olibga bittadan.
   *
   * BO'SH ro'yxat normal holat va u "sovrin yo'q" degani EMAS: efirda bitta sovrin bo'lganini,
   * ya'ni uni `prizeLabel` berishini bildiradi. Efirlarning aksariyati shunday, va bu holat
   * uchun ro'yxatni majburiy qilish har bir jadvalga qo'yishga ortiqcha ish qo'shardi.
   *
   * `winnerCount` kabi, bu ham VA'DA: efirdan oldin e'lon qilinadi va tortishuv o'tkazilgach
   * o'zgartirilmaydi.
   */
  prizes: z6.array(z6.string()),
  /** External video embed (YouTube/Telegram) for D3. Null before the broadcast is set up. */
  videoEmbedUrl: z6.string().url().nullable(),
  /**
   * Efir ko'rsatiladimi. `false` bo'lsa D1 kartasi D3 ga OLIB BORMAYDI va D3 jonli sahna
   * o'rniga tinch izoh chizadi — efir vaqti xato bo'lgan yoki efir bo'lmagan kunlar uchun.
   * Tortishuvning o'ziga aloqasi yo'q: g'olib baribir tanlanadi va D4 da e'lon qilinadi.
   */
  liveEnabled: z6.boolean(),
  /**
   * Bu efirda nechta g'olib chiqadi (§3 ning kengaytmasi, default 1).
   *
   * Kartada e'lon sifatida ko'rinadi: "3 ta g'olib" — va shu va'da efirdan oldin beriladi,
   * ya'ni tortishuv o'tkazilgandan keyin o'zgartirilmaydi.
   */
  winnerCount: z6.number().int().positive(),
  /** Eligible ticket count, revealed as the first live step. */
  ticketCount: z6.number().int().nonnegative().nullable()
});
var publicDrawWinnerSchema = z6.object({
  ticketId: idSchema,
  ticketCode: z6.string(),
  /** Masked for public listings (D4): e.g. `Ali K.`. Empty when the account has no first name. */
  userDisplayName: z6.string(),
  /**
   * Bu g'olib AYNAN nima yutgani — tortishuv paytida muhrlangan qiymat.
   *
   * `null` = efirda bitta sovrin bo'lgan; o'shanda ekran `draw.prizeLabel` ni ko'rsatadi. Ikkita
   * manba ATAYLAB: yagona maydon qilinganda arxivdagi har bir g'olibga qiymat ko'chirilishi
   * kerak bo'lardi, va o'sha ko'chirish `prizeLabel` keyin tahrirlanganda tarixni jimgina
   * ikkiga bo'lardi.
   */
  prizeLabel: z6.string().nullable()
});
var drawWinnerSchema = publicDrawWinnerSchema.extend({
  /** True only in the requesting user's own view (D4b). */
  isMe: z6.boolean()
});
var drawRevealKindSchema = z6.enum([
  DrawRevealKind.TICKET_COUNT,
  DrawRevealKind.SHORTLIST,
  DrawRevealKind.WINNER
]);
var MAX_PROGRESSIVE_TICKET_CHARACTERS = 32;
var progressiveShortlistPayloadSchema = z6.object({
  codePrefix: z6.string().startsWith("QT-"),
  revealedCharacters: z6.number().int().positive(),
  // Bounds every UI allocation (`repeat`, slot grids) even when parsing arbitrary legacy JSON.
  totalCharacters: z6.number().int().positive().max(MAX_PROGRESSIVE_TICKET_CHARACTERS),
  candidateCount: z6.number().int().nonnegative()
}).strict().superRefine((payload, context) => {
  if (payload.revealedCharacters > payload.totalCharacters) {
    context.addIssue({
      code: z6.ZodIssueCode.custom,
      path: ["revealedCharacters"],
      message: "revealedCharacters cannot exceed totalCharacters"
    });
  }
  if (payload.codePrefix.length !== "QT-".length + payload.revealedCharacters) {
    context.addIssue({
      code: z6.ZodIssueCode.custom,
      path: ["codePrefix"],
      message: "codePrefix length must match revealedCharacters"
    });
  }
});
var drawRevealStepSchema = z6.object({
  seq: z6.number().int().positive(),
  kind: drawRevealKindSchema,
  payload: z6.record(z6.unknown()),
  revealedAt: isoDateTimeSchema
});
var drawStateSchema = z6.object({
  draw: drawSchema,
  steps: z6.array(drawRevealStepSchema),
  lastSeq: z6.number().int().nonnegative(),
  /**
   * E'LON QILINGAN g'oliblar, efirdagi tartibda.
   *
   * Ro'yxat, chunki bitta efir bir nechta g'olib chiqarishi mumkin. Faqat o'z bosqichi efirga
   * chiqqanlari bo'ladi: hali e'lon qilinmagan g'olib bu yerda YO'Q, aks holda snapshot
   * efirning qolgan qismini oldindan aytib qo'yardi.
   */
  winners: z6.array(drawWinnerSchema),
  /** The requesting user's tickets in this draw, highlighted on D3. */
  myTicketCodes: z6.array(z6.string())
});
var broadcastDrawStateSchema = z6.object({
  draw: drawSchema,
  steps: z6.array(drawRevealStepSchema),
  lastSeq: z6.number().int().nonnegative(),
  winners: z6.array(publicDrawWinnerSchema),
  /**
   * Hozir shu efirni ko'rib turgan soketlar soni — ekranda «hozir N kishi tomosha qilyapti»
   * kadri, operator uchun esa jonli kanal ishlayotganining dalili.
   *
   * MAJBURIY va har doim son: soket qatlami javob bermasa server 0 yuboradi. Ixtiyoriy qilinsa
   * overlay «yo'q» bilan «nol»ni farqlashga majbur bo'lardi, holbuki efirda ikkalasi ham bir xil
   * ko'rinadi — va bitta hisoblagich tufayli butun holatni yo'qotib bo'lmaydi.
   */
  viewerCount: z6.number().int().nonnegative()
});
var drawListResponseSchema = paginated(drawSchema);
var winnersListResponseSchema = paginated(
  drawSchema.pick({
    id: true,
    type: true,
    drawDate: true,
    monthKey: true,
    prizeLabel: true,
    prizes: true
  }).extend({
    winners: z6.array(drawWinnerSchema)
  })
);

// src/contracts/referrals.ts
import { z as z7 } from "zod";
var referredFriendSchema = z7.object({
  id: idSchema,
  displayName: z7.string(),
  joinedAt: isoDateTimeSchema,
  /**
   * The bonus only fires on the friend's first `details_ready` receipt — until then the row
   * shows as pending, which is exactly what the "Eslatish" button is for.
   */
  rewarded: z7.boolean(),
  rewardedAt: isoDateTimeSchema.nullable()
});
var referralOverviewSchema = z7.object({
  /** `t.me/<bot>?start=ref_<user_id>` built server-side so the bot name lives in one config. */
  inviteLink: z7.string().url(),
  /** Referral tickets received this week against the 50/week cap. */
  weeklyTickets: meterSchema,
  totalInvited: z7.number().int().nonnegative(),
  totalRewarded: z7.number().int().nonnegative(),
  totalPointsEarned: z7.number().int().nonnegative(),
  friends: z7.array(referredFriendSchema)
});

// src/contracts/profile.ts
import { z as z8 } from "zod";
var meResponseSchema = z8.object({
  user: authUserSchema,
  limits: limitsSchema,
  tickets: ticketCountsSchema
});
var updateNotificationPrefsRequestSchema = z8.object({
  broadcastOptOut: z8.boolean()
});
var pointTransactionTypeSchema = z8.enum([
  PointTransactionType.RECEIPT_REWARD,
  PointTransactionType.RECEIPT_OVER_LIMIT_REWARD,
  PointTransactionType.PHOTO_REWARD,
  PointTransactionType.REFERRAL_REWARD,
  PointTransactionType.REVERSAL,
  PointTransactionType.ADMIN_ADJUSTMENT
]);
var pointTransactionSchema = z8.object({
  id: idSchema,
  type: pointTransactionTypeSchema,
  /** Negative for reversals. */
  amount: z8.number().int(),
  balanceAfter: z8.number().int(),
  createdAt: isoDateTimeSchema,
  receiptId: idSchema.nullable(),
  photoScanId: idSchema.nullable()
});
var pointTransactionListResponseSchema = paginated(pointTransactionSchema);
var scanHistoryEntrySchema = z8.discriminatedUnion("kind", [
  z8.object({ kind: z8.literal("receipt"), receipt: receiptSummarySchema }),
  z8.object({ kind: z8.literal("photo"), photo: photoScanSummarySchema })
]);
var scanHistoryResponseSchema = paginated(scanHistoryEntrySchema);

// src/contracts/internal.ts
import { z as z9 } from "zod";
var receiptDetailsJobSchema = z9.object({
  receiptId: idSchema,
  /** Full QR URL — the scraper opens exactly this, no reconstruction. */
  url: z9.string().url(),
  /** Attempt counter for logging; BullMQ owns the real retry state. */
  enqueuedAt: z9.string()
});
var receiptClaimRequestSchema = z9.object({
  /** Batch size. The API clamps to its own ceiling regardless of what is asked. */
  max: z9.number().int().min(1).max(50).default(10)
});
var claimedReceiptSchema = z9.object({
  receiptId: idSchema,
  /** The exact QR URL to open — the scraper never reconstructs it. */
  url: z9.string().url()
});
var receiptClaimResponseSchema = z9.object({
  receipts: z9.array(claimedReceiptSchema)
});
var receiptExtraDetailsSchema = z9.record(z9.union([z9.string(), z9.number(), z9.null()]));
var scrapedItemSchema = z9.object({
  name: z9.string().min(1).max(500),
  /** PER UNIT — the API's independent total check is `SUM(price × quantity)`. */
  price: somSchema,
  quantity: z9.number().nonnegative(),
  details: receiptExtraDetailsSchema.optional()
});
var receiptDetailsResultSchema = z9.object({
  receiptId: idSchema,
  merchantName: z9.string().max(500).nullable(),
  /** Total as printed on the page; the API compares it with the QR-derived total. */
  totalAmount: somSchema.nullable(),
  items: z9.array(scrapedItemSchema).min(1).max(RECEIPT_MAX_ITEMS),
  /** Page-level extras (fiscal module, cashier, payment split, VAT total, coordinates, …). */
  details: receiptExtraDetailsSchema.optional(),
  /** Scraper-side timing, for the success-rate metric that drives degraded mode. */
  fetchedAt: z9.string()
});
var receiptFailureCategorySchema = z9.enum(["terminal", "pending_publication"]);
var receiptDetailsFailureSchema = z9.object({
  receiptId: idSchema,
  reason: z9.string().max(1e3),
  /** True when the scraper believes the failure is systemic (page shape changed, captcha). */
  systemic: z9.boolean().default(false),
  attempt: z9.number().int().nonnegative(),
  /** Defaults to `terminal` so a scraper build predating P6.2 keeps its old meaning. */
  category: receiptFailureCategorySchema.default("terminal")
});
var healthResponseSchema = z9.object({
  status: z9.enum(["ok", "degraded", "down"]),
  service: z9.string(),
  version: z9.string(),
  uptimeSeconds: z9.number().nonnegative(),
  checks: z9.record(z9.enum(["ok", "down", "skipped"]))
});

// src/contracts/admin.ts
import { z as z10 } from "zod";
var videoEmbedUrlSchema = z10.string().max(500).superRefine((value, ctx) => {
  let url;
  try {
    url = new URL(value);
  } catch {
    ctx.addIssue({ code: z10.ZodIssueCode.custom, message: "Not a URL" });
    return;
  }
  if (url.protocol !== "https:") {
    ctx.addIssue({ code: z10.ZodIssueCode.custom, message: "Video embed URL must be https" });
    return;
  }
  if (!DRAW_VIDEO_EMBED_ALLOWED_HOSTS.includes(url.hostname)) {
    ctx.addIssue({
      code: z10.ZodIssueCode.custom,
      message: `Video embed host not allowed: ${url.hostname}`
    });
  }
});
var scheduleDrawRequestSchema = z10.object({
  type: drawTypeSchema,
  /**
   * Kunlik va HAFTALIK efir uchun majburiy.
   *
   * Kunlik efirda — efir kuni. Haftalik efirda — o'sha haftaning DUSHANBASI, ya'ni qaysi
   * haftaning biletlari o'ynashi (efirning o'zi hafta yopilgach bo'lib o'tadi va uning
   * vaqti `scheduledAt` da). Dushanba ekani quyida tekshiriladi.
   */
  drawDate: dayKeySchema.optional(),
  /** Oylik uchun majburiy — qaysi OYning biletlari o'ynaydi (efir keyingi oyning boshida). */
  monthKey: monthKeySchema.optional(),
  scheduledAt: isoDateTimeSchema,
  /**
   * Butun efirning sovrini — bitta sovrinli efir uchun, va ko'p sovrinli efirda kartadagi
   * yig'ma matn. `prizes` berilganda ham MAJBURIY bo'lib qoladi: D1 kartasi, eslatma va
   * arxiv ro'yxati bitta qatorlik matn kutadi va uni ro'yxatdan yasab bo'lmaydi.
   */
  prizeLabel: z10.string().min(1).max(DRAW_PRIZE_LABEL_MAX_LENGTH),
  /**
   * Har bir g'olibga alohida sovrin.
   *
   * Berilmasa tegilmaydi (mavjud ro'yxat saqlanadi); BO'SH massiv — ro'yxatni o'chirish, ya'ni
   * "hamma bitta sovrinni oladi" holatiga qaytish. Ikkovi bir xil emas, shuning uchun
   * `.optional()` va bo'sh massiv ikkita alohida ma'no.
   *
   * O'rinlar YO'Q: tartib faqat biriktiruvni takrorlanadigan qilish uchun, "birinchi sovrin
   * qimmatroq" degan ma'no bermaydi.
   */
  prizes: z10.array(z10.string().trim().min(1).max(DRAW_PRIZE_LABEL_MAX_LENGTH)).max(DRAW_MAX_WINNERS).optional(),
  /** `null` — mavjud havolani o'chirish; berilmasa, eski qiymat saqlanadi. */
  videoEmbedUrl: videoEmbedUrlSchema.nullable().optional(),
  /** Berilmasa tegilmaydi; `false` — efir mini appda ko'rsatilmaydi. */
  liveEnabled: z10.boolean().optional(),
  /**
   * Nechta g'olib chiqadi. Berilmasa tegilmaydi (yangi qator uchun 1).
   *
   * Yuqori chegara — texnik emas, EFIR chegarasi: har bir g'olib alohida marosim bilan
   * e'lon qilinadi, ya'ni o'nta g'olib bir soatlik efir demakdir.
   */
  winnerCount: z10.number().int().min(1).max(DRAW_MAX_WINNERS).optional()
}).superRefine((value, ctx) => {
  const expectsDay = value.type !== DrawType.MONTHLY;
  if (expectsDay && !value.drawDate) {
    ctx.addIssue({
      code: z10.ZodIssueCode.custom,
      path: ["drawDate"],
      message: `Required for a ${value.type} draw`
    });
  }
  if (!expectsDay && !value.monthKey) {
    ctx.addIssue({
      code: z10.ZodIssueCode.custom,
      path: ["monthKey"],
      message: "Required for a monthly draw"
    });
  }
  if (expectsDay && value.monthKey) {
    ctx.addIssue({
      code: z10.ZodIssueCode.custom,
      path: ["monthKey"],
      message: `Not allowed for a ${value.type} draw`
    });
  }
  if (!expectsDay && value.drawDate) {
    ctx.addIssue({
      code: z10.ZodIssueCode.custom,
      path: ["drawDate"],
      message: "Not allowed for a monthly draw"
    });
  }
  if (value.type === DrawType.WEEKLY && value.drawDate) {
    if (getZonedParts(dayKeyToInstant(value.drawDate)).isoWeekday !== WEEK_START_ISO_WEEKDAY) {
      ctx.addIssue({
        code: z10.ZodIssueCode.custom,
        path: ["drawDate"],
        message: "A weekly draw period must be the Monday of the week that plays"
      });
    }
  }
  if (value.prizes && value.prizes.length > 0 && value.winnerCount !== void 0) {
    if (value.prizes.length !== value.winnerCount) {
      ctx.addIssue({
        code: z10.ZodIssueCode.custom,
        path: ["prizes"],
        message: `Expected ${value.winnerCount} prizes, got ${value.prizes.length}`
      });
    }
  }
});
var setDrawLiveRequestSchema = z10.object({ enabled: z10.boolean() });
var runDailyDrawRequestSchema = z10.object({
  /** Which day's tickets play. Defaults to yesterday in Asia/Tashkent. */
  drawDate: dayKeySchema.optional()
});
var runWeeklyDrawRequestSchema = z10.object({
  /** Qaysi HAFTA o'ynaydi — o'sha haftaning dushanbasi. Berilmasa: o'tgan hafta. */
  weekKey: dayKeySchema.optional()
});
var runMonthlyDrawRequestSchema = z10.object({
  monthKey: monthKeySchema.optional(),
  prizeLabel: z10.string().min(1).max(DRAW_PRIZE_LABEL_MAX_LENGTH).optional()
});
var adminDrawWinnerSchema = z10.object({
  ticketId: idSchema,
  ticketCode: z10.string(),
  userId: idSchema,
  telegramId: z10.string(),
  userDisplayName: z10.string(),
  username: z10.string().nullable(),
  /**
   * Bu g'olibga muhrlangan sovrin — operator AYNAN shuni topshiradi.
   *
   * `null` = efirda bitta sovrin bo'lgan (`draw.prizeLabel`). Konsolda ko'rinishi shart: ko'p
   * sovrinli efirdan keyin "kimga nima" degan savolga javob beradigan yagona joy shu.
   */
  prizeLabel: z10.string().nullable()
});
var adminDrawSchema = drawSchema.extend({
  lastSeq: z10.number().int().nonnegative(),
  postponedReason: z10.string().nullable(),
  /** Efir eslatmasi navbatga qo'yilgan payt — jadval ko'rinishida "eslatma ketdi" belgisi. */
  reminderQueuedAt: isoDateTimeSchema.nullable(),
  /**
   * G'oliblar e'loni navbatga qo'yilgan payt — `null` bo'lsa tugma hali bosilmagan.
   *
   * Konsoldagi tugmaning holati AYNAN shu maydondan chiqadi, mahalliy `isSuccess` dan emas:
   * e'lon butun bazaga ketadi va sahifa yangilangach tugma yana "bosilmagan" ko'rinsa, operator
   * uni ikkinchi marta bosadi.
   */
  winnersAnnouncedAt: isoDateTimeSchema.nullable(),
  revealedKinds: z10.array(drawRevealKindSchema),
  /** Tanlangan g'oliblar — konsolda spoyler niqobi YO'Q (§3.6.2). */
  winners: z10.array(adminDrawWinnerSchema)
});
var adminDrawDetailSchema = adminDrawSchema.extend({
  /**
   * Ofset bu yerda QO'LLANMAYDI. `DRAW_REVEAL_OFFSET_MS` — tomoshabin uchun ko'rinish qoidasi;
   * bosqichni e'lon qilgan odam esa uni darhol ko'rishi kerak, aks holda konsol o'zi yuborgan
   * bosqichni bir necha soniya "yo'q" deb ko'rsatadi va boshlovchi tugmani ikkinchi marta bosadi.
   */
  steps: z10.array(drawRevealStepSchema),
  /**
   * Efir overlay'i holatni oxirgi marta o'qiganidan beri o'tgan vaqt (ms) — `null` bo'lsa
   * hech qachon o'qimagan.
   *
   * Konsol shu bitta maydondan OBS manbasining tirikligini hukm qiladi. Muzlab qolgan manba
   * so'rov yubormay qo'yadi, lekin ekranda oxirgi kadr turaveradi — ya'ni buzilganini KO'RSATADIGAN
   * yagona narsa shu.
   *
   * VAQT EMAS, YOSH: bu maydon ataylab mutlaq sana emas. Sana bo'lganida konsol uni O'Z soatiga
   * solishtirardi, ya'ni hukm ikki xil soatga tayanardi. Chegara 5 s, ya'ni operator noutbukining
   * soati yarim daqiqa orqada bo'lsa signal umuman ishlamas, oldinda bo'lsa esa har efirda yolg'on
   * chinqirardi — ikkalasi ham jimgina. Yoshni SERVER hisoblaydi (u ikkala vaqtning ham egasi),
   * konsol esa javob kelganidan beri o'tgan vaqtni o'zining bitta soati bilan qo'shib qo'yadi;
   * ayirma soat farqidan qat'i nazar to'g'ri qoladi.
   */
  overlayAgeMs: z10.number().int().nonnegative().nullable()
});
var broadcastOverlayAccessSchema = z10.object({
  accessToken: z10.string().min(1),
  expiresIn: z10.number().int().positive()
});
var adminDrawListResponseSchema = offsetPaginated(adminDrawSchema).extend({
  statusCounts: z10.record(z10.number().int().nonnegative())
});
var runDrawResponseSchema = z10.object({
  draw: adminDrawSchema,
  /** Tanlangan g'oliblar — `draw.winners` bilan bir xil, javobning o'zida ham qulaylik uchun. */
  winners: z10.array(adminDrawWinnerSchema),
  eligibleTicketCount: z10.number().int().nonnegative()
});
var revealStepRequestSchema = z10.object({
  kind: drawRevealKindSchema,
  payload: z10.record(z10.unknown()).default({}),
  /** Optimistic concurrency guard: the console advances exactly the state it rendered. */
  expectedLastSeq: z10.number().int().nonnegative()
});
var postponeDrawRequestSchema = z10.object({
  reason: z10.string().max(500).optional()
});
var announceWinnersResponseSchema = z10.object({
  draw: adminDrawDetailSchema,
  /** Nechta foydalanuvchi navbatga qo'yildi (g'oliblar va rad etganlar chiqarilgandan keyin). */
  recipients: z10.number().int().nonnegative(),
  /** Oxirgi xabar yuboriladigan payt — `null` bo'lsa navbatga hech kim tushmadi. */
  lastScheduledFor: isoDateTimeSchema.nullable()
});
var adminReceiptFilterSchema = z10.object({
  status: receiptStatusSchema.optional(),
  userId: idSchema.optional(),
  from: dayKeySchema.optional(),
  to: dayKeySchema.optional()
});
var adminReceiptRowSchema = receiptSummarySchema.extend({
  userId: idSchema,
  telegramId: z10.string(),
  fiscalKey: z10.string(),
  merchantName: z10.string().nullable(),
  outcome: z10.string(),
  /** `page_total` | `item_lines` | `unverified` — null until the scraper reports. */
  totalVerifiedBy: z10.string().nullable(),
  detailsAttempts: z10.number().int().nonnegative(),
  lastError: z10.string().nullable(),
  itemCount: z10.number().int().nonnegative()
});
var adminReceiptListResponseSchema = offsetPaginated(adminReceiptRowSchema);
var adminPhotoFilterSchema = z10.object({
  status: photoScanStatusSchema.optional(),
  subject: photoSubjectSchema.optional(),
  userId: idSchema.optional()
});
var adminPhotoRowSchema = photoScanSummarySchema.extend({
  userId: idSchema,
  telegramId: z10.string(),
  visionProvider: z10.string().nullable(),
  recognisedItemCount: z10.number().int().nonnegative()
});
var adminPhotoListResponseSchema = offsetPaginated(adminPhotoRowSchema);
var adminFraudTicketSchema = ticketSchema.extend({
  userId: idSchema,
  telegramId: z10.string(),
  source: ticketSourceSchema,
  receiptId: idSchema.nullable(),
  photoScanId: idSchema.nullable(),
  /** Chek da'vo qilgan summa (`receipts.total_amount`) — rasm bileti uchun `null`. */
  receiptTotal: somSchema.nullable(),
  receiptTotalVerifiedBy: z10.string().nullable(),
  receiptStatus: receiptStatusSchema.nullable(),
  /** `verified_at` — bilet tortishuvga kira oladimi. `fraud_review` da odatda `null`. */
  verifiedAt: isoDateTimeSchema.nullable()
});
var adminFraudTicketListResponseSchema = offsetPaginated(adminFraudTicketSchema);
var ticketModerationRequestSchema = z10.object({
  action: z10.enum(["restore", "revoke"]),
  /**
   * Status to restore to; ignored for `revoke`.
   *
   * Berilmasa — server biletning O'Z sanalaridan hisoblaydi (`expectedTicketStatus`), ya'ni
   * hayot-sikl qoidasining ikkinchi nusxasi hosil bo'lmaydi. Bu maydon operator uchun qo'lda
   * chetlab o'tish yo'li bo'lib qoladi.
   */
  restoreTo: z10.enum([
    TicketStatus.PENDING_DAILY,
    TicketStatus.PLAYED_DAILY,
    TicketStatus.IN_WEEKLY_POOL,
    TicketStatus.IN_MONTHLY_POOL
  ]).optional(),
  reason: z10.string().max(500)
});
var ticketModerationResponseSchema = z10.object({
  ticket: adminFraudTicketSchema,
  compensated: z10.boolean(),
  /** Bilet ko'chirilgan oy (yoki o'z oyi, agar ko'chirish shart bo'lmasa). */
  monthKey: monthKeySchema
});
var dlqEntrySchema = z10.object({
  jobId: z10.string(),
  receiptId: idSchema.nullable(),
  reason: z10.string(),
  attempts: z10.number().int().nonnegative(),
  failedAt: isoDateTimeSchema,
  payload: z10.record(z10.unknown())
});
var dlqListResponseSchema = offsetPaginated(dlqEntrySchema).extend({
  /** `false` — navbat umuman ulanmagan (Redis yo'q), ya'ni bo'sh ro'yxat "xato yo'q" degani EMAS. */
  available: z10.boolean()
});
var adminNotificationFilterSchema = z10.object({
  status: z10.enum([NotificationStatus.QUEUED, NotificationStatus.SENT, NotificationStatus.FAILED]).optional(),
  drawId: idSchema.optional(),
  type: z10.enum([
    NotificationType.RECEIPT_REVOKED,
    NotificationType.RECEIPT_POINTS_CREDITED,
    NotificationType.DRAW_WIN,
    NotificationType.DRAW_REMINDER,
    NotificationType.DRAW_RESULT,
    NotificationType.REFERRAL_BONUS,
    NotificationType.REWARD_DELIVERED,
    NotificationType.REWARD_CANCELLED
  ]).optional(),
  /**
   * `true` — faqat QOTIB QOLGANLARI: yetkazilmagan va o'z-o'zidan ketmaydiganlari.
   *
   * Alohida filtr, `status=failed` ning taxallusi EMAS. Ikkita boshqa-boshqa nosozlik bor va
   * ularning ikkinchisi statusda umuman ko'rinmaydi: `failed` qator — urinishlari tugagani,
   * `queued` qator esa muddati o'tib ketgani bilan qotadi (dispatcher yetishmayapti yoki
   * da'vo oqib ketgan). Operator "nega xabar bormadi" deb qaraganda ikkalasi ham kerak.
   *
   * `z.coerce.boolean()` EMAS: u bo'sh bo'lmagan har qanday satrni rost deb o'qiydi, ya'ni
   * `stuck=false` filtrni o'chirish o'rniga yoqib qo'yardi.
   */
  stuck: z10.enum(["true", "false"]).transform((value) => value === "true").optional(),
  /** Foydalanuvchi bo'yicha: telegram id, ism yoki telefon raqamining bir qismi. */
  query: z10.string().max(200).optional(),
  /** `created_at` oralig'i — kun kaliti (`2026-08-17`), Toshkent kuni bo'yicha. */
  from: dayKeySchema.optional(),
  to: dayKeySchema.optional()
});
var adminNotificationRowSchema = z10.object({
  id: idSchema,
  userId: idSchema,
  telegramId: z10.string(),
  /** Kim ekanini panelda telegram id dan tiklab o'tirmaslik uchun. */
  displayName: z10.string(),
  phoneNumber: z10.string().nullable(),
  type: z10.string(),
  status: z10.string(),
  drawId: idSchema.nullable(),
  attempts: z10.number().int().nonnegative(),
  lastError: z10.string().nullable(),
  createdAt: isoDateTimeSchema,
  sentAt: isoDateTimeSchema.nullable(),
  /** `null` — «imkon boricha tez»; sana — «bundan oldin emas» (backoff yoki ommaviy tarqatish). */
  scheduledFor: isoDateTimeSchema.nullable(),
  /** Yuborilayotgan payt ushlab turiladigan ijara; muddati o'tgani — o'lgan jarayon izi. */
  claimedUntil: isoDateTimeSchema.nullable(),
  /**
   * Bu uchtasi SERVERDA hisoblanadi va bu ataylab.
   *
   * "Qotib qolgan" va "qayta urinsa bo'ladi" — qoidalar, ko'rinish emas: ularni panelda
   * takrorlash ikkinchi implementatsiya bo'lardi, va ikkitasi ajralib ketganda tugma
   * bosilgan bo'lardi-yu, server rad etardi.
   */
  stuck: z10.boolean(),
  retryable: z10.boolean(),
  /** Nega qayta urinib bo'lmaydi — operatorga ko'rsatiladigan sabab. */
  blockedReason: z10.enum(["user_blocked", "bot_blocked", "chat_not_found", "already_sent", "not_stuck"]).nullable()
});
var adminNotificationListResponseSchema = offsetPaginated(adminNotificationRowSchema);
var adminNotificationStatsSchema = z10.object({
  queued: z10.number().int().nonnegative(),
  sent: z10.number().int().nonnegative(),
  failed: z10.number().int().nonnegative(),
  stuck: z10.number().int().nonnegative(),
  /** Qayta urinish tugmasi nechtasiga ta'sir qiladi — bosishdan oldin ko'rinadi. */
  retryable: z10.number().int().nonnegative(),
  /** Eng eski qotgan qatorning yoshi, daqiqada. `null` — qotgani yo'q. */
  oldestStuckMinutes: z10.number().int().nonnegative().nullable(),
  byType: z10.array(z10.object({ type: z10.string(), stuck: z10.number().int().nonnegative() }))
});
var adminRetryNotificationsRequestSchema = z10.object({
  ids: z10.array(idSchema).min(1).max(500).optional(),
  all: z10.boolean().optional(),
  filter: adminNotificationFilterSchema.optional()
}).superRefine((value, ctx) => {
  if (!value.all && (!value.ids || value.ids.length === 0)) {
    ctx.addIssue({
      code: z10.ZodIssueCode.custom,
      message: "Either specific ids or all: true must be provided"
    });
  }
});
var adminRetryNotificationsResponseSchema = z10.object({
  retriedCount: z10.number().int().nonnegative(),
  /** Tanlanganlardan nechtasi qayta urinib bo'lmasligi sababli chetda qoldi. */
  skippedCount: z10.number().int().nonnegative()
});
var adminUserLookupSchema = offsetPaginationQuerySchema.extend({
  query: z10.string().max(200).optional()
});
var adminUserSummarySchema = z10.object({
  id: idSchema,
  telegramId: z10.string(),
  username: z10.string().nullable(),
  displayName: z10.string(),
  /**
   * Botdagi `request_contact` orqali TASDIQLANGAN raqam (`null` — ulashmagan).
   *
   * Panelda ko'rinishi kerak, chunki sovrinni topshirish shu raqam bilan boshlanadi: g'olib
   * bilet raqami bo'yicha topiladi, keyin esa odamga qo'ng'iroq qilinadi. Bu maydonsiz
   * operatorning yagona yo'li bazaga to'g'ridan-to'g'ri so'rov yozish edi — 2026-08-12 kungi
   * efirda aynan shunday bo'ldi.
   */
  phoneNumber: z10.string().nullable(),
  /** `users.current_balance` — denormalizatsiya qilingan ustun. */
  currentBalance: pointsSchema,
  isBlocked: z10.boolean(),
  createdAt: isoDateTimeSchema
});
var adminUserSearchResponseSchema = offsetPaginated(adminUserSummarySchema);
var adminLedgerRowSchema = z10.object({
  id: idSchema,
  type: z10.string(),
  amount: pointsSchema,
  balanceAfter: pointsSchema,
  note: z10.string().nullable(),
  createdAt: isoDateTimeSchema
});
var adminUserDetailSchema = z10.object({
  user: adminUserSummarySchema,
  ledgerBalance: pointsSchema,
  ticketCounts: z10.record(z10.number().int().nonnegative()),
  /**
   * Bilet ro'yxati — spoyler niqobi YO'Q (P3.5 dagi qoida: g'olibni tanlagan ham, e'lon
   * qiladigan ham shu panel).
   */
  tickets: z10.array(ticketSchema.extend({ status: ticketStatusSchema })),
  receipts: z10.array(adminReceiptRowSchema),
  photos: z10.array(adminPhotoRowSchema),
  ledger: z10.array(adminLedgerRowSchema)
});
var adminExportQuerySchema = z10.object({
  from: dayKeySchema,
  to: dayKeySchema
}).superRefine((value, ctx) => {
  const from = dayKeyToInstant(value.from).getTime();
  const to = dayKeyToInstant(value.to).getTime();
  if (to < from) {
    ctx.addIssue({
      code: z10.ZodIssueCode.custom,
      path: ["to"],
      message: "Range ends before it starts"
    });
    return;
  }
  const days = Math.round((to - from) / 864e5) + 1;
  if (days > ADMIN_EXPORT_MAX_RANGE_DAYS) {
    ctx.addIssue({
      code: z10.ZodIssueCode.custom,
      path: ["to"],
      message: `Range must not exceed ${ADMIN_EXPORT_MAX_RANGE_DAYS} days`
    });
  }
});
var adminAccountRowSchema = adminAccountSchema.extend({
  isActive: z10.boolean(),
  lastLoginAt: isoDateTimeSchema.nullable(),
  createdAt: isoDateTimeSchema
});
var adminAccountListResponseSchema = z10.object({
  items: z10.array(adminAccountRowSchema)
});
var adminOwnerSchema = z10.object({
  id: idSchema,
  telegramId: z10.string(),
  username: z10.string().nullable(),
  displayName: z10.string(),
  currentBalance: pointsSchema,
  isBlocked: z10.boolean()
});
var adminLinkedTicketSchema = z10.object({
  id: idSchema,
  code: z10.string(),
  status: ticketStatusSchema
});
var adminReceiptItemSchema = z10.object({
  id: idSchema,
  name: z10.string(),
  price: somSchema,
  /** Miqdor kasrli bo'lishi mumkin (kilogramm), shuning uchun SATR sifatida keladi. */
  quantity: z10.string(),
  position: z10.number().int().nonnegative()
});
var adminReceiptDetailSchema = z10.object({
  receipt: adminReceiptRowSchema,
  owner: adminOwnerSchema,
  qrRaw: z10.string(),
  url: z10.string(),
  weekKey: dayKeySchema,
  weeklySeq: z10.number().int().nullable(),
  revokedReason: z10.string().nullable(),
  detailsFetchedAt: isoDateTimeSchema.nullable(),
  nextRetryAt: isoDateTimeSchema.nullable(),
  ticket: adminLinkedTicketSchema.nullable(),
  items: z10.array(adminReceiptItemSchema),
  ledger: z10.array(adminLedgerRowSchema)
});
var adminPhotoItemSchema = z10.object({
  id: idSchema,
  name: z10.string(),
  /** AI aytgan dastlabki nom — foydalanuvchi tuzatgan bo'lsa, farq shu yerda ko'rinadi. */
  originalName: z10.string(),
  confidence: z10.number().nullable(),
  confirmed: z10.boolean(),
  edited: z10.boolean(),
  position: z10.number().int().nonnegative()
});
var adminPhotoDetailSchema = z10.object({
  photo: adminPhotoRowSchema,
  owner: adminOwnerSchema,
  imageUrl: z10.string(),
  imageExpiresAt: isoDateTimeSchema,
  contentType: z10.string().nullable(),
  sizeBytes: z10.number().int().nonnegative().nullable(),
  confirmedAt: isoDateTimeSchema.nullable(),
  outcome: z10.string().nullable(),
  ticket: adminLinkedTicketSchema.nullable(),
  items: z10.array(adminPhotoItemSchema),
  ledger: z10.array(adminLedgerRowSchema)
});
var adminStatMetricSchema = z10.object({
  total: z10.number().int().nonnegative(),
  today: z10.number().int().nonnegative(),
  week: z10.number().int().nonnegative()
});
var adminStatPointSchema = z10.object({
  /** Toshkent kuni, `YYYY-MM-DD`. */
  day: dayKeySchema,
  users: z10.number().int().nonnegative(),
  receipts: z10.number().int().nonnegative(),
  photos: z10.number().int().nonnegative(),
  meals: z10.number().int().nonnegative(),
  tickets: z10.number().int().nonnegative()
});
var adminStatsSchema = z10.object({
  /** Javob qachon HISOBLANGAN — keshdan kelgan bo'lsa, bu "hozir" emas. */
  generatedAt: isoDateTimeSchema,
  users: adminStatMetricSchema.extend({
    blocked: z10.number().int().nonnegative()
  }),
  tickets: adminStatMetricSchema.extend({
    statusCounts: z10.record(z10.number().int().nonnegative())
  }),
  receipts: adminStatMetricSchema.extend({
    statusCounts: z10.record(z10.number().int().nonnegative()),
    revoked: z10.number().int().nonnegative()
  }),
  photos: adminStatMetricSchema.extend({
    statusCounts: z10.record(z10.number().int().nonnegative())
  }),
  meals: adminStatMetricSchema.extend({
    statusCounts: z10.record(z10.number().int().nonnegative())
  }),
  points: z10.object({
    /** Berilgan ballar yig'indisi (musbat harakatlar). */
    issued: z10.number().int().nonnegative(),
    /** Qaytarilgan/yechilgan ballar yig'indisi, MUSBAT son sifatida. */
    reversed: z10.number().int().nonnegative(),
    /** Hozirda foydalanuvchilar qo'lidagi balanslar yig'indisi. */
    balance: pointsSchema,
    issuedToday: z10.number().int().nonnegative()
  }),
  draws: z10.object({
    total: z10.number().int().nonnegative(),
    statusCounts: z10.record(z10.number().int().nonnegative())
  }),
  /**
   * Kutib turgan ish — operatorning "hozir nima qilishim kerak" degan savoli.
   *
   * Boshqa bo'limlardan ajratilgan: qolganlari o'tmish haqida, bu esa hozir haqida.
   */
  queues: z10.object({
    fraudReview: z10.number().int().nonnegative(),
    photosInReview: z10.number().int().nonnegative(),
    receiptsPending: z10.number().int().nonnegative(),
    notificationsFailed: z10.number().int().nonnegative()
  }),
  /** Oxirgi `ADMIN_STATS_TREND_DAYS` kun, eng eskisi birinchi. */
  trend: z10.array(adminStatPointSchema)
});
var adminReasonSchema = z10.string().transform((value) => value.trim()).pipe(z10.string().min(3).max(500));
var adminUserBlockRequestSchema = z10.object({
  isBlocked: z10.boolean(),
  reason: adminReasonSchema
});
var adminUserPointsRequestSchema = z10.object({
  amount: z10.number().int().refine((value) => value !== 0, { message: "Amount must not be zero" }).refine((value) => Math.abs(value) <= ADMIN_POINTS_ADJUST_MAX, {
    message: `Amount must be within \xB1${ADMIN_POINTS_ADJUST_MAX}`
  }),
  reason: adminReasonSchema
});
var adminTicketGrantRequestSchema = z10.object({
  /** Qaysi kunning tortishuviga tushsin. Berilmasa — bugun (Toshkent). */
  acquiredDate: dayKeySchema.optional(),
  reason: adminReasonSchema
});
var adminPhotoModerationRequestSchema = z10.object({
  action: z10.enum(["approve", "reject"]),
  reason: adminReasonSchema
});
var adminAccountActiveRequestSchema = z10.object({
  isActive: z10.boolean(),
  reason: z10.string().max(500).optional()
});
var AdminAuditAction = {
  LOGIN: "admin.login",
  /** Rad etilgan urinish — `admin_id` bo'sh, `admin_email` esa kiritilgan qiymat. */
  LOGIN_FAILED: "admin.login_failed",
  DRAW_SCHEDULE: "draw.schedule",
  DRAW_RUN_DAILY: "draw.run_daily",
  DRAW_RUN_WEEKLY: "draw.run_weekly",
  DRAW_RUN_MONTHLY: "draw.run_monthly",
  DRAW_POSTPONE: "draw.postpone",
  /** Efir mini appda yoqildi/o'chirildi — tortishuvning o'ziga tegmaydigan ko'rinish qarori. */
  DRAW_LIVE_TOGGLE: "draw.live_toggle",
  DRAW_REVEAL: "draw.reveal",
  /** G'oliblar butun bazaga e'lon qilindi — ortga qaytarib bo'lmaydigan yagona efir tugmasi. */
  DRAW_ANNOUNCE_WINNERS: "draw.announce_winners",
  DRAW_OVERLAY_ACCESS: "draw.overlay_access",
  /** `fraud_review` navbati: bilet tiklandi (kerak bo'lsa joriy oyga ko'chirilgan holda). */
  TICKET_RESTORE: "ticket.restore",
  /** `fraud_review` navbati: bilet bekor qilindi. */
  TICKET_REVOKE: "ticket.revoke",
  /**
   * Bitta foydalanuvchining butun tarixi o'qildi.
   *
   * O'QISH uchun audit yozuvi ATAYLAB: bu shaxsiy ma'lumotga maqsadli murojaat, va §4.13 ning
   * "kim, nimani, qachon" savoli aynan shunga tegishli. Ro'yxat/qidiruv yozilmaydi — har bir
   * harf uchun qator yozish muhim izni ko'mib yuborardi.
   */
  USER_LOOKUP: "user.lookup",
  /** Efir eslatmasi sinov uchun bitta chatga yuborildi — bot orqali tashqariga chiqqan xabar. */
  NOTIFICATION_TEST: "notification.test",
  /** CSV eksport — kim qaysi oraliqni yuklab oldi. */
  DATA_EXPORT: "data.export",
  /** Foydalanuvchi bloklandi / blokdan chiqarildi — sabab bilan. */
  USER_BLOCK: "user.block",
  USER_UNBLOCK: "user.unblock",
  /** Ball qo'lda tuzatildi. Pul harakati, ya'ni yozuvsiz bo'lmaydi. */
  USER_POINTS_ADJUST: "user.points_adjust",
  /** Kompensatsiya bileti qo'lda berildi. */
  TICKET_GRANT: "ticket.grant",
  /** Rasm skani bo'yicha moderator qarori. */
  PHOTO_APPROVE: "photo_scan.approve",
  PHOTO_REJECT: "photo_scan.reject",
  ADMIN_ACCOUNT_ACTIVATE: "admin_account.activate",
  ADMIN_ACCOUNT_DEACTIVATE: "admin_account.deactivate",
  /** Ball-katalog (P8): sovg'a qo'shildi / tahrirlandi / o'chirildi. */
  REWARD_CREATE: "reward_catalog.create",
  REWARD_UPDATE: "reward_catalog.update",
  REWARD_DELETE: "reward_catalog.delete",
  /** Asosiy ekran bannerlari: qo'shildi / tahrirlandi / o'chirildi. */
  BANNER_CREATE: "banner.create",
  BANNER_UPDATE: "banner.update",
  BANNER_DELETE: "banner.delete",
  /** Degraded mode: yoqildi / o'chirildi / reset qilindi. */
  DEGRADED_MODE_SET: "system.degraded_mode_set",
  /** Bot xabari shabloni tahrirlandi yoki standartga qaytarildi. */
  NOTIFICATION_TEMPLATE_SET: "notification_template.set",
  NOTIFICATION_TEMPLATE_RESET: "notification_template.reset",
  /** Muvaffaqiyatsiz chek(lar) qayta navbatga kiritildi (retry). */
  RECEIPT_RETRY: "receipt.retry",
  /** Qotib qolgan xabar(lar) qayta navbatga kiritildi. */
  NOTIFICATION_RETRY: "notification.retry",
  /**
   * Sovg'a buyurtmasi (P8.1). `CANCEL` — BALL QAYTARADIGAN tugma, ya'ni pul harakati: uning
   * `metadata` sida sabab ham, qaytarilgan miqdor ham bo'ladi.
   */
  REWARD_REDEMPTION_DELIVER: "reward_redemption.deliver",
  REWARD_REDEMPTION_CANCEL: "reward_redemption.cancel"
};
var AdminAuditTarget = {
  ADMIN_USER: "admin_user",
  DRAW: "draw",
  RECEIPT: "receipt",
  TICKET: "ticket",
  USER: "user",
  /** Eksportning o'zi — `target_id` yo'q, oraliq `metadata` da. */
  EXPORT: "export",
  /** Ball-katalog elementi (P8). */
  REWARD_CATALOG: "reward_catalog",
  /** Sovg'a buyurtmasi (P8.1) — `target_id` `reward_redemptions.id`. */
  REWARD_REDEMPTION: "reward_redemption",
  /** Asosiy ekran banneri. */
  BANNER: "banner",
  /** Rasm skani — moderator qarori shu maqsad ustida yoziladi. */
  PHOTO_SCAN: "photo_scan",
  /** Tizim parametrlari / Degraded mode holati. */
  SYSTEM: "system",
  /** Bot xabari shabloni — `target_id` shablonning kaliti. */
  NOTIFICATION_TEMPLATE: "notification_template",
  /** Navbatdagi xabar — `target_id` bitta qator bo'lganda uning id si. */
  NOTIFICATION: "notification"
};
var adminRetryFailedReceiptsRequestSchema = z10.object({
  receiptIds: z10.array(idSchema).min(1).max(500).optional(),
  all: z10.boolean().optional()
}).superRefine((value, ctx) => {
  if (!value.all && (!value.receiptIds || value.receiptIds.length === 0)) {
    ctx.addIssue({
      code: z10.ZodIssueCode.custom,
      message: "Either specific receiptIds or all: true must be provided"
    });
  }
});
var adminRetryFailedReceiptsResponseSchema = z10.object({
  retriedCount: z10.number().int().nonnegative()
});
var adminDegradedModeStatusSchema = z10.object({
  active: z10.boolean(),
  reason: z10.string().nullable(),
  since: isoDateTimeSchema.nullable(),
  automatic: z10.boolean(),
  sampleSize: z10.number().int().nonnegative()
});
var adminSetDegradedModeRequestSchema = z10.object({
  active: z10.boolean(),
  reason: z10.string().max(500).optional()
});
var adminAuditLogEntrySchema = z10.object({
  id: idSchema,
  /** `null` — hisobi o'chirilgan admin: yozuv qoladi, havola uziladi (FK `SetNull`). */
  adminId: idSchema.nullable(),
  adminEmail: z10.string(),
  action: z10.string(),
  targetType: z10.string(),
  targetId: z10.string().nullable(),
  metadata: z10.record(z10.unknown()),
  createdAt: isoDateTimeSchema
});
var adminTicketDetailSchema = z10.object({
  ticket: adminFraudTicketSchema,
  owner: adminOwnerSchema,
  receipt: adminReceiptRowSchema.nullable(),
  photo: adminPhotoRowSchema.nullable(),
  audit: z10.array(adminAuditLogEntrySchema)
});

// src/contracts/rewards.ts
import { z as z11 } from "zod";
var rewardCatalogItemSchema = z11.object({
  id: idSchema,
  name: z11.string().min(1).max(200),
  pointsCost: z11.number().int().positive(),
  /** Short-lived read URL resolved from the stored image key; null when no image was uploaded. */
  imageUrl: z11.string().url().nullable()
});
var rewardCatalogResponseSchema = z11.object({
  items: z11.array(rewardCatalogItemSchema)
});
var adminRewardItemSchema = rewardCatalogItemSchema.extend({
  /** The raw storage key (present so the admin edit form knows an image exists). */
  imageKey: z11.string().nullable(),
  position: z11.number().int(),
  active: z11.boolean(),
  createdAt: isoDateTimeSchema,
  updatedAt: isoDateTimeSchema
});
var adminRewardListResponseSchema = z11.object({
  items: z11.array(adminRewardItemSchema)
});
var adminRewardCreateSchema = z11.object({
  name: z11.string().min(1).max(200),
  pointsCost: z11.number().int().positive(),
  imageKey: z11.string().max(500).optional(),
  position: z11.number().int().nonnegative().optional(),
  active: z11.boolean().optional()
});
var adminRewardUpdateSchema = adminRewardCreateSchema.partial().refine((value) => Object.keys(value).length > 0, {
  message: "At least one field must be provided"
});
var rewardRedemptionStatusSchema = z11.enum([
  RewardRedemptionStatus.PENDING,
  RewardRedemptionStatus.DELIVERED,
  RewardRedemptionStatus.CANCELLED
]);
var rewardRedemptionSchema = z11.object({
  id: idSchema,
  itemName: z11.string(),
  imageUrl: z11.string().url().nullable(),
  pointsSpent: z11.number().int().positive(),
  status: rewardRedemptionStatusSchema,
  createdAt: isoDateTimeSchema,
  /** Yetkazilgan yoki bekor qilingan payt; `pending` da `null`. */
  decidedAt: isoDateTimeSchema.nullable()
});
var redeemRewardResponseSchema = z11.object({
  redemption: rewardRedemptionSchema,
  currentBalance: z11.number().int().nonnegative()
});
var rewardRedemptionListResponseSchema = z11.object({
  items: z11.array(rewardRedemptionSchema)
});
var adminRewardRedemptionRowSchema = z11.object({
  id: idSchema,
  userId: idSchema,
  telegramId: z11.string(),
  displayName: z11.string(),
  /** Yetkazish uchun yagona aloqa kanali — buyurtma paytidagi nusxasi. */
  phoneNumber: z11.string().nullable(),
  /** `null` — katalog bandi o'chirilgan (o'chirish bloklangan, ya'ni amalda kutilmaydi). */
  rewardItemId: idSchema.nullable(),
  itemName: z11.string(),
  pointsSpent: z11.number().int().positive(),
  status: rewardRedemptionStatusSchema,
  createdAt: isoDateTimeSchema,
  decidedAt: isoDateTimeSchema.nullable(),
  /** Denormalizatsiya: admin hisobi o'chirilsa ham kim qaror qilgani qoladi. */
  decidedByEmail: z11.string().nullable(),
  /** Ichki izoh — yetkazish sharhi yoki bekor qilish sababi. Foydalanuvchiga ko'rinmaydi. */
  adminNote: z11.string().nullable()
});
var adminRewardRedemptionFilterSchema = z11.object({
  status: rewardRedemptionStatusSchema.optional(),
  rewardItemId: idSchema.optional(),
  /** Foydalanuvchi bo'yicha: telegram id, ism yoki telefon raqamining bir qismi. */
  query: z11.string().max(200).optional(),
  /** `created_at` oralig'i — kun kaliti (`2026-08-17`), Toshkent kuni bo'yicha. */
  from: dayKeySchema.optional(),
  to: dayKeySchema.optional()
});
var adminRewardRedemptionListResponseSchema = offsetPaginated(
  adminRewardRedemptionRowSchema
);
var adminRewardRedemptionStatsSchema = z11.object({
  pending: z11.number().int().nonnegative(),
  delivered: z11.number().int().nonnegative(),
  cancelled: z11.number().int().nonnegative(),
  /** Hozir `pending` da ushlanib turgan ball — hali hech kimga bermagan majburiyat. */
  pendingPoints: z11.number().int().nonnegative()
});
var adminDeliverRewardRedemptionRequestSchema = z11.object({
  note: z11.string().trim().max(500).optional()
});
var adminCancelRewardRedemptionRequestSchema = z11.object({
  reason: adminReasonSchema
});

// src/contracts/banners.ts
import { z as z12 } from "zod";
var bannerSchema = z12.object({
  id: idSchema,
  /** Short-lived read URL resolved from the stored image key. */
  imageUrl: z12.string().url(),
  /**
   * Where a tap goes. Read together with {@link bannerSchema.shape.external}: when `external` is
   * false this is an INTERNAL route key the front resolves itself (e.g. "rewards"); when it is
   * true this is an absolute `http(s)` URL the front opens in a new tab.
   */
  link: z12.string().min(1).max(2e3),
  /** `false` — in-app route; `true` — outside link, opened with `target="_blank"`. */
  external: z12.boolean()
});
var bannerListResponseSchema = z12.object({
  items: z12.array(bannerSchema)
});
var adminBannerSchema = z12.object({
  id: idSchema,
  imageKey: z12.string(),
  imageUrl: z12.string().url().nullable(),
  link: z12.string().min(1).max(2e3),
  external: z12.boolean(),
  position: z12.number().int(),
  active: z12.boolean(),
  createdAt: isoDateTimeSchema,
  updatedAt: isoDateTimeSchema
});
var adminBannerListResponseSchema = z12.object({
  items: z12.array(adminBannerSchema)
});
var adminBannerCreateSchema = z12.object({
  imageKey: z12.string().min(1).max(500),
  link: z12.string().min(1).max(2e3),
  /**
   * Marks `link` as an outside URL rather than an in-app route key. Optional on the wire so
   * existing callers keep creating internal banners; the column defaults to `false`.
   */
  external: z12.boolean().optional(),
  position: z12.number().int().nonnegative().optional(),
  active: z12.boolean().optional()
});
var adminBannerUpdateSchema = adminBannerCreateSchema.partial().refine((value) => Object.keys(value).length > 0, {
  message: "At least one field must be provided"
});

// src/contracts/uploads.ts
import { z as z13 } from "zod";
var adminUploadKindSchema = z13.enum(["banner", "reward"]);
var ADMIN_UPLOAD_MAX_BYTES = 5 * 1024 * 1024;
var adminUploadRequestSchema = z13.object({
  kind: adminUploadKindSchema,
  contentType: z13.enum(["image/jpeg", "image/png", "image/webp"]),
  contentLength: z13.number().int().positive().max(ADMIN_UPLOAD_MAX_BYTES)
});
var adminUploadResponseSchema = z13.object({
  /** The client PUTs the bytes straight here. */
  uploadUrl: z13.string().url(),
  /** Headers the client must replay on the PUT, or the signature will not match. */
  uploadHeaders: z13.record(z13.string()),
  /** The storage key to persist on the banner/reward once the PUT succeeds. */
  key: z13.string()
});

// src/contracts/notification-templates.ts
import { z as z14 } from "zod";
var notificationTemplateKeySchema = z14.string().min(1).max(120).regex(/^[a-z_]+(:[a-z_]+)?$/, "key must be <type> or <type>:<variant>");
var notificationTemplateBodySchema = z14.string().min(1).max(4096).refine(isValidTelegramHtml, "body contains HTML that Telegram will not parse");
var notificationTemplateButtonUrlSchema = z14.string().min(1).max(500);
var notificationTemplateSchema = z14.object({
  key: notificationTemplateKeySchema,
  body: notificationTemplateBodySchema,
  /** Tugma yozuvi. `null` — tugma yo'q. */
  buttonLabel: z14.string().min(1).max(64).nullable(),
  buttonUrl: notificationTemplateButtonUrlSchema.nullable(),
  /** `false` — hali hech kim tahrir qilmagan, ya'ni fayl/standart matn ko'rsatilyapti. */
  overridden: z14.boolean(),
  updatedAt: isoDateTimeSchema.nullable(),
  updatedByEmail: z14.string().nullable(),
  /** Shu shablonda ishlatsa bo'ladigan `{...}` lar — admin panel ularni ro'yxat qilib beradi. */
  placeholders: z14.array(z14.string())
});
var notificationTemplateListResponseSchema = z14.object({
  items: z14.array(notificationTemplateSchema)
});
var adminUpdateNotificationTemplateRequestSchema = z14.object({
  body: notificationTemplateBodySchema,
  buttonLabel: z14.string().min(1).max(64).nullable().optional(),
  buttonUrl: notificationTemplateButtonUrlSchema.nullable().optional()
}).superRefine((value, ctx) => {
  const hasLabel = Boolean(value.buttonLabel);
  const hasUrl = Boolean(value.buttonUrl);
  if (hasLabel !== hasUrl) {
    ctx.addIssue({
      code: z14.ZodIssueCode.custom,
      path: [hasLabel ? "buttonUrl" : "buttonLabel"],
      message: "buttonLabel and buttonUrl must be set together"
    });
  }
});
var adminPreviewNotificationTemplateResponseSchema = z14.object({
  text: z14.string(),
  buttonLabel: z14.string().nullable(),
  buttonUrl: z14.string().nullable()
});
var adminSendTestNotificationRequestSchema = z14.object({
  /** Telegram chat id — odatda operatorning o'z hisobi. */
  chatId: z14.string().regex(/^-?\d+$/, "Chat id faqat raqamlardan iborat bo'ladi"),
  body: notificationTemplateBodySchema.optional(),
  buttonLabel: z14.string().min(1).max(64).nullable().optional(),
  buttonUrl: notificationTemplateButtonUrlSchema.nullable().optional()
});
var adminSendTestNotificationResponseSchema = z14.object({
  ok: z14.boolean(),
  /** Telegram qaytargan matn — `ok: false` bo'lganda sababning o'zi. */
  error: z14.string().nullable(),
  /**
   * Tugma qo'shildimi. `false` — matn ketdi, LEKIN tugmasiz: manzil to'ldirilmagan yoki
   * `TELEGRAM_MINIAPP_URL` sozlanmagan. Jimgina "yuborildi" deyish operatorni tugma
   * ishlayapti deb o'ylashga qoldirardi.
   */
  hasButton: z14.boolean()
});

// src/sockets/events.ts
function drawNamespace(key) {
  return `${DRAW_SOCKET_NAMESPACE_PREFIX}${key}`;
}
var DRAW_NAMESPACE_PATTERN = new RegExp(
  `^/${DRAW_SOCKET_NAMESPACE_PREFIX}\\d{4}-\\d{2}(-\\d{2})?$`
);
var SocketEvent = {
  /** Server → client: one revealed step. */
  DRAW_REVEAL: "draw:reveal",
  /** Server → client: draw status changed (completed / postponed). */
  DRAW_STATUS: "draw:status",
  /** Server → client: the winner step, always the last one. */
  DRAW_WINNER: "draw:winner",
  /** Client → server: join a draw room. */
  DRAW_JOIN: "draw:join",
  /** Client → server: leave. */
  DRAW_LEAVE: "draw:leave"
};
function hasSequenceGap(lastSeen, incoming) {
  return incoming !== lastSeen + 1;
}
export {
  ACCESS_TOKEN_TTL_SECONDS,
  ACCOUNT_DELETION_DAYS,
  ADMIN_ACCESS_TOKEN_TTL_SECONDS,
  ADMIN_EXPORT_CHUNK_SIZE,
  ADMIN_EXPORT_MAX_RANGE_DAYS,
  ADMIN_LOGIN_RATE_LIMIT_PER_MINUTE,
  ADMIN_PAGE_SIZES,
  ADMIN_PHOTO_READ_TTL_SECONDS,
  ADMIN_POINTS_ADJUST_MAX,
  ADMIN_STATS_CACHE_SECONDS,
  ADMIN_STATS_TREND_DAYS,
  ADMIN_TICKET_AUDIT_LIMIT,
  ADMIN_UPLOAD_MAX_BYTES,
  ADMIN_USER_HISTORY_LIMIT,
  ADMIN_USER_LOOKUP_AUDIT_WINDOW_MS,
  AdminAuditAction,
  AdminAuditTarget,
  AdminRole,
  BROADCAST_OVERLAY_POLL_INTERVAL_MS,
  BROADCAST_OVERLAY_REQUESTS_PER_MINUTE,
  BROADCAST_OVERLAY_SEEN_TTL_SECONDS,
  BROADCAST_OVERLAY_STALE_AFTER_MS,
  BROADCAST_OVERLAY_TOKEN_TTL_SECONDS,
  DAILY_DRAW_PRIZE_SOM,
  DAILY_DRAW_TIME_HHMM,
  DAILY_DRAW_WINNER_COUNT,
  DAILY_FOOD_PHOTO_LIMIT,
  DAILY_SCAN_TICKET_LIMIT,
  DEGRADED_MODE_RETRY_DELAY_MS,
  DEGRADED_MODE_SAMPLE_SIZE,
  DEGRADED_MODE_SKIPS_REVOCATION,
  DEGRADED_MODE_SUCCESS_RATIO_THRESHOLD,
  DRAW_CULMINATION_CANDIDATE_MAX,
  DRAW_FIRST_SEQ,
  DRAW_INELIGIBLE_TICKET_STATUSES,
  DRAW_MAX_WINNERS,
  DRAW_NAMESPACE_PATTERN,
  DRAW_PRIZE_LABEL_MAX_LENGTH,
  DRAW_REMINDER_CRON,
  DRAW_REMINDER_LEAD_MINUTES,
  DRAW_REVEAL_OFFSET_MS_DEFAULT,
  DRAW_SOCKET_NAMESPACE_PREFIX,
  DRAW_VIDEO_EMBED_ALLOWED_HOSTS,
  DrawRevealKind,
  DrawStatus,
  DrawType,
  ERROR_SCREEN,
  ErrorCode,
  FOOD_MAX_RECOGNISED_ITEMS,
  FOOD_POINTS,
  FixedClock,
  HMAC_MAX_CLOCK_SKEW_MS,
  HMAC_SIGNATURE_HEADER,
  HMAC_TIMESTAMP_HEADER,
  IDEMPOTENCY_IN_FLIGHT_TIMEOUT_SECONDS,
  IDEMPOTENCY_KEY_HEADER,
  IDEMPOTENCY_TTL_SECONDS,
  INITDATA_MAX_AGE_SECONDS,
  INVALID_ORIGIN_BLOCK_SECONDS,
  INVALID_ORIGIN_STRIKE_LIMIT,
  MAX_PROGRESSIVE_TICKET_CHARACTERS,
  MONTHLY_DRAW_TIME_HHMM,
  MONTHLY_DRAW_WINNER_COUNT,
  NOTIFICATION_BACKOFF_BASE_MS,
  NOTIFICATION_CLAIM_LEASE_MS,
  NOTIFICATION_DISPATCH_CRON,
  NOTIFICATION_MAX_ATTEMPTS,
  NOTIFICATION_STUCK_AFTER_MS,
  NotificationStatus,
  NotificationType,
  OFERTA_MIN_AGE_YEARS,
  OVER_LIMIT_RECEIPT_MAX_TOTAL,
  OVER_LIMIT_RECEIPT_MIN_TOTAL,
  OVER_LIMIT_RECEIPT_POINTS,
  PENDING_PUBLICATION_MAX_AGE_MS,
  PENDING_PUBLICATION_RETRY_DELAYS_MS,
  PHOTO_ALLOWED_MIME_TYPES,
  PHOTO_ITEM_NAME_MAX_LENGTH,
  PHOTO_MAX_RECOGNISED_ITEMS,
  PHOTO_MAX_UPLOAD_BYTES,
  PHOTO_MIN_CONFIRMED_ITEMS,
  PHOTO_POINTS,
  PHOTO_RECOGNITION_RATE_LIMIT_PER_MINUTE,
  PRESIGNED_READ_TTL_SECONDS,
  PRESIGNED_UPLOAD_TTL_SECONDS,
  PhotoScanOutcome,
  PhotoScanStatus,
  PhotoSubject,
  PointTransactionType,
  QUEUE_DLQ_RETENTION_SECONDS,
  QUEUE_SUCCESS_RETENTION_SECONDS,
  REALTIME_REDIS_CONNECT_TIMEOUT_MS,
  RECEIPT_DETAILS_DLQ,
  RECEIPT_DETAILS_QUEUE,
  RECEIPT_MAX_AGE_DAYS,
  RECEIPT_MAX_ITEMS,
  RECEIPT_POINTS_RATE,
  RECONCILIATION_CRON,
  RECONCILIATION_MIN_AGE_MS,
  REFERRAL_FRIENDS_LIST_LIMIT,
  REFERRAL_POINTS,
  REFERRAL_START_PARAM_PREFIX,
  REFERRAL_TICKETS,
  REFRESH_TOKEN_TTL_SECONDS,
  ReceiptScanOutcome,
  ReceiptStatus,
  RewardRedemptionStatus,
  SCAN_RATE_LIMIT_PER_IP_PER_MINUTE,
  SCAN_RATE_LIMIT_PER_MINUTE,
  SCAN_TICKET_SOURCES,
  SCRAPER_BACKOFF_BASE_MS,
  SCRAPER_CLAIM_BATCH,
  SCRAPER_JOB_TIMEOUT_MS,
  SCRAPER_MAX_ATTEMPTS,
  SCRAPER_POLL_INTERVAL_MS,
  SCRAPER_RESTART_AFTER_JOBS,
  SCRAPER_RESTART_AFTER_MS,
  SENTRY_REDACTED,
  SLOT_CONTENTION_RETRIES,
  SURVEY_CALLBACK_PREFIX,
  SURVEY_FIELD_WINDOW_HOURS,
  SURVEY_ID,
  SURVEY_REWARD_POINTS,
  SURVEY_SPEED_FILTER_SECONDS,
  SocketEvent,
  SystemClock,
  TELEGRAM_HTML_TAGS,
  TELEGRAM_MAX_MESSAGES_PER_SECOND,
  TERMINAL_TICKET_STATUSES,
  TICKETS_PER_FOOD,
  TICKETS_PER_PHOTO,
  TICKETS_PER_RECEIPT,
  TICKET_POOL_CRON,
  TIMEZONE,
  TIMEZONE_UTC_OFFSET_MINUTES,
  TicketSource,
  TicketStatus,
  WEEKLY_DRAW_TIME_HHMM,
  WEEKLY_RECEIPT_LIMIT,
  WEEKLY_REFERRAL_TICKET_CAP,
  WEEK_START_ISO_WEEKDAY,
  WELCOME_POINTS,
  accessTokenClaimsSchema,
  addLocalDays,
  adminAccountActiveRequestSchema,
  adminAccountListResponseSchema,
  adminAccountRowSchema,
  adminAccountSchema,
  adminAuditLogEntrySchema,
  adminBannerCreateSchema,
  adminBannerListResponseSchema,
  adminBannerSchema,
  adminBannerUpdateSchema,
  adminCancelRewardRedemptionRequestSchema,
  adminDegradedModeStatusSchema,
  adminDeliverRewardRedemptionRequestSchema,
  adminDrawDetailSchema,
  adminDrawListResponseSchema,
  adminDrawSchema,
  adminDrawWinnerSchema,
  adminExportQuerySchema,
  adminFraudTicketListResponseSchema,
  adminFraudTicketSchema,
  adminLedgerRowSchema,
  adminLinkedTicketSchema,
  adminLoginRequestSchema,
  adminNotificationFilterSchema,
  adminNotificationListResponseSchema,
  adminNotificationRowSchema,
  adminNotificationStatsSchema,
  adminOwnerSchema,
  adminPhotoDetailSchema,
  adminPhotoFilterSchema,
  adminPhotoItemSchema,
  adminPhotoListResponseSchema,
  adminPhotoModerationRequestSchema,
  adminPhotoRowSchema,
  adminPreviewNotificationTemplateResponseSchema,
  adminReasonSchema,
  adminReceiptDetailSchema,
  adminReceiptFilterSchema,
  adminReceiptItemSchema,
  adminReceiptListResponseSchema,
  adminReceiptRowSchema,
  adminRetryFailedReceiptsRequestSchema,
  adminRetryFailedReceiptsResponseSchema,
  adminRetryNotificationsRequestSchema,
  adminRetryNotificationsResponseSchema,
  adminRewardCreateSchema,
  adminRewardItemSchema,
  adminRewardListResponseSchema,
  adminRewardRedemptionFilterSchema,
  adminRewardRedemptionListResponseSchema,
  adminRewardRedemptionRowSchema,
  adminRewardRedemptionStatsSchema,
  adminRewardUpdateSchema,
  adminSendTestNotificationRequestSchema,
  adminSendTestNotificationResponseSchema,
  adminSessionSchema,
  adminSetDegradedModeRequestSchema,
  adminStatMetricSchema,
  adminStatPointSchema,
  adminStatsSchema,
  adminTicketDetailSchema,
  adminTicketGrantRequestSchema,
  adminTokenClaimsSchema,
  adminUpdateNotificationTemplateRequestSchema,
  adminUploadKindSchema,
  adminUploadRequestSchema,
  adminUploadResponseSchema,
  adminUserBlockRequestSchema,
  adminUserDetailSchema,
  adminUserLookupSchema,
  adminUserPointsRequestSchema,
  adminUserSearchResponseSchema,
  adminUserSummarySchema,
  announceWinnersResponseSchema,
  authSessionSchema,
  authTokensSchema,
  authUserSchema,
  bannerListResponseSchema,
  bannerSchema,
  broadcastDrawStateSchema,
  broadcastOverlayAccessSchema,
  broadcastOverlayTokenClaimsSchema,
  calendarDaysBetween,
  canStartFoodScan,
  canStartPhotoScan,
  claimedReceiptSchema,
  dayKey,
  dayKeySchema,
  dayKeyToInstant,
  decideFoodReward,
  decidePhotoReward,
  decideReceiptScan,
  dlqEntrySchema,
  dlqListResponseSchema,
  drawListResponseSchema,
  drawNamespace,
  drawRevealKindSchema,
  drawRevealStepSchema,
  drawSchema,
  drawStateSchema,
  drawStatusSchema,
  drawTypeSchema,
  drawWinnerSchema,
  errorBodySchema,
  escapeTelegramHtml,
  expectedTicketStatus,
  findTelegramHtmlProblems,
  getZonedParts,
  hasDailyFoodCapacity,
  hasDailyTicketCapacity,
  hasSequenceGap,
  healthResponseSchema,
  idSchema,
  isReceiptFresh,
  isValidTelegramHtml,
  isWithinOverLimitBand,
  isWithinWeeklyReceiptLimit,
  isoDateTimeSchema,
  limitsSchema,
  logoutRequestSchema,
  maskedTicketStatus,
  meResponseSchema,
  meterSchema,
  monthKey,
  monthKeySchema,
  monthKeyToInstant,
  notificationTemplateBodySchema,
  notificationTemplateButtonUrlSchema,
  notificationTemplateKeySchema,
  notificationTemplateListResponseSchema,
  notificationTemplateSchema,
  offsetPaginated,
  offsetPaginationQuerySchema,
  paginated,
  paginationQuerySchema,
  percentagePoints,
  photoConfirmResponseSchema,
  photoItemSchema,
  photoReviewRequestSchema,
  photoScanDetailSchema,
  photoScanListResponseSchema,
  photoScanOutcomeSchema,
  photoScanRequestSchema,
  photoScanResponseSchema,
  photoScanStatusSchema,
  photoScanSummarySchema,
  photoSubjectSchema,
  photoUploadUrlRequestSchema,
  photoUploadUrlResponseSchema,
  pointTransactionListResponseSchema,
  pointTransactionSchema,
  pointTransactionTypeSchema,
  pointsSchema,
  postponeDrawRequestSchema,
  previousMonthKey,
  previousWeekKey,
  progressiveShortlistPayloadSchema,
  publicDrawWinnerSchema,
  receiptClaimRequestSchema,
  receiptClaimResponseSchema,
  receiptDetailSchema,
  receiptDetailsFailureSchema,
  receiptDetailsJobSchema,
  receiptDetailsResultSchema,
  receiptExtraDetailsSchema,
  receiptFailureCategorySchema,
  receiptItemSchema,
  receiptListResponseSchema,
  receiptPointsForTotal,
  receiptScanOutcomeSchema,
  receiptScanRequestSchema,
  receiptScanResponseSchema,
  receiptStatusSchema,
  receiptSummarySchema,
  redeemRewardResponseSchema,
  referralOverviewSchema,
  referralTicketsToGrant,
  referredFriendSchema,
  refreshRequestSchema,
  revealStepRequestSchema,
  rewardCatalogItemSchema,
  rewardCatalogResponseSchema,
  rewardRedemptionListResponseSchema,
  rewardRedemptionSchema,
  rewardRedemptionStatusSchema,
  runDailyDrawRequestSchema,
  runDrawResponseSchema,
  runMonthlyDrawRequestSchema,
  runWeeklyDrawRequestSchema,
  scanHistoryEntrySchema,
  scanHistoryResponseSchema,
  scheduleDrawRequestSchema,
  scrapedItemSchema,
  scrubSentryEvent,
  scrubSentryString,
  setDrawLiveRequestSchema,
  somSchema,
  startOfDay,
  startOfMonth,
  startOfNextDay,
  startOfNextMonth,
  startOfNextWeek,
  startOfWeek,
  telegramLoginRequestSchema,
  ticketCountsSchema,
  ticketListResponseSchema,
  ticketModerationRequestSchema,
  ticketModerationResponseSchema,
  ticketSchema,
  ticketSourceSchema,
  ticketStatusSchema,
  toOffsetPage,
  updateNotificationPrefsRequestSchema,
  videoEmbedUrlSchema,
  weekEndDayKey,
  weekKey,
  weekKeyToInstant,
  winnersListResponseSchema,
  zoneOffsetMs,
  zonedTimeToUtc
};
//# sourceMappingURL=index.js.map